/*
 *###############################################################################
 *Module Name                   : Transaction.js                                #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  T A C Priyashad                              #
 *Date                          : Wednesday, October 08th 2021, 2:24:18 pm      #
 *Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
 *###############################################################################
 */

 import React, { useState, useEffect, useRef } from "react"
 import MetaTags from "react-meta-tags"
 
 /* Import reactstrap Libries */
 import {
   Card,
   CardBody,
   Col,
   Container,
   Row,
   TabContent,
   TabPane,
   Alert
 } from "reactstrap"
 /* End Import reactstrap Libries */
 
 //Import Breadcrumb
 import Breadcrumbs from "../../../components/Common/Breadcrumb"
 /* Import myPOS Framework Component */
 import DPNavBar from "../../../framework/widgets/DPNavBar"
 import DPTopToolBar from "../../../framework/widgets/DPTopToolBar"
 import { Text, Numeric, DecimalValidation } from "../../../framework/validators/TextValidation"
 import DPAlert from "../../../framework/widgets/DPAlert"
 import DPInfoBox from "framework/layout/DPInfoBox"
 import mobileman from "../../../assets/images/logo/mobileman.png"
 import excelicon from "../../../assets/images/logo/excelicon.png"
 
 import {
   NetCalculation,
   getLineDicTotal,
   SendFCM,
   GetPermissionList,
   CancelTransaction,
   GetDetailAgainstBOM,
   getSubDocs,
   getTxnLocations,
   HandleDetailTable,
   GetValidateExcelProducts,
   GetSupplierTax,
   transOBJ,
   PaymentObj,
   GetShelfManager,
   MobileManTransaction,
   GetTxn,
   GetReferenceDoc,
   GetAutoOrder,
   getCheckSIH,
   GetHeaderReasonTypes,
   getLocationSupplier,
   RemarkValidation,
   GetSupplierDetails,
   GetCustomerDetails,
   GetSalesAssistDetails,
   GetProduct,
   GetBOM,
   calculateFromAndToValue,
   GetMonthend,
   getApprovalStatusAndMessage,
   FocusOnEvent,
   getTransactionTax,
   handleExcelUpload,
   getMobileManDocumentDetailsUserWise,
   getMobileManDocumentDetails,
   modifyGridTable,
   getSupplierCredit,
   GetDetailReasonTypes,
   getConsignmnetDatail,
   exportTransactionDataToExcel
 } from "../Transaction/TransactionController"
 import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
 import DPPermission from "framework/widgets/DPPermission"
 import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
 
 /* End Import myPOS Framework Component */
 
 /* Import  Content widgets */
 import TransactionHED from "./TransactionHED"
 import TransactionDET from "./TransactionDet"
 import TransactionRemHED from "./TransactionRemHED"
 import TransactionAttach from "./TransactionAttach"
 import Approvel from "./Approvel"
 import PendingApprovels from "./Support-Widgets/PendingApprovels"
 import { GetRules } from "./TransactionController"
 import DPPrintOption from "framework/widgets/DPPrintOptions"
 
 import TransactionSubDocs from "./TransactionSubDocs"
 import { Context } from "app-contexts/CommonContexts"
 import { useContext } from "react"
 import DPTxnProduct from "framework/components/DPTxnProduct"
 import { CalculateTaxAmount, CalculateTaxAmountFromDetailTable, CalculateTaxFrom, ModifyTaxGrid, ModifyTaxGridFromExcel, ModifyTaxGridFromMobileMan, TaxCalculateFromExcel } from "./TransactionTAX"
 import { useHistory } from 'react-router-dom';
 import DPMobilePopUp from "framework/components/DPMobilePopUp"
 import DPTxnProductSIH from "framework/components/DPTxnProductSIH"
 import { isNull } from "lodash"
 import { MobileManUserModel } from "./MobileManUserModel"
import { FormatNumberTODecimal } from "components/helpers/FormatNumberTODecimal"
import DateRangeModal from "./Support-Widgets/DateRangeModal"
import ModelUserPermission from "./Support-Widgets/ModelUserPermission"
import { wait } from "@testing-library/react"
import { MENUPERMISSION_GPVARIANCE } from "Permission_Rules"
 
 const Transaction = props => {
   let history = useHistory();
   /*
     empty array for transaction object
   */
 
   let searchPara = props.location.search.replace("?", "").toUpperCase(); // 'GRN&1000100000053&0001'
 
   const params = searchPara.split('&'); // ['GRN', '1000100000053', '0001']
 
   const type = params.length > 0 ? params[0] : ""; // Extracts 'GRN'
   const inv = params.length > 1 ? params[1] : ""; // Extracts '1000100000053'
   const urlLocation = params.length > 2 ? params[2] : ""; // Extracts '0001'
 
 
   const ApiURL = window.Links.ApiURL
 
   const {
     isHeadOffice, menus, getMenuDetails, endOfDate, txnDecimalAmt, txnDecimalQty, setupLocation, MenuUserpermission, masterAuditLog, addtoFavourite, getSelectedMasterPermissions, isWMS
   } = useContext(Context);
 
   //**Transaction useStates */
   const [txn, setTxn] = useState({})
   let time = process.env.REACT_APP_ALERTTIMEOUT; // alert display time in seconds 
   const authToken = localStorage.getItem("authToken") // Auth Token 
 
   const [modal_xlargeM, setmodal_xlargeM] = useState(false)
   const [handleClearStatus, setHandleClearStatus] = useState(false)
 
 
   const defaultSorted = [
     {
       dataField: "id",
       order: "asc",
     }
   ]
   const fileInputRef = useRef(null);
 
   const [subDocs, setSubDocs] = useState([])
   const [subDocApprove, setSubDocApprove] = useState(true)
   const [productErrorToggle, setProductErrorToggle] = useState(false)
   const [ProductErrorData, setProductErrorData] = useState([])
   const [currentRunningMonth, setCurrentRunningMonth] = useState("")
   const [currentRunningYear, setCurrentRunningYear] = useState("")
   const [txnTaxTypes, setTxnTaxTypes] = useState([])
   const [calTax , setCalTax] = useState(true)
 
   const [productSIHChangesData, setProductSIHChangesData] = useState([])
   const [productSIHChangesToggle, setProductSIHChangesToggle] = useState(false)
 
   const [menuCreate, SetMenuCreate] = useState(false)
   const [menuDelete, SetMenuDelete] = useState(false)
   const [menuModify, SetMenuModify] = useState(false)
   const [menuPrint, SetMenuPrint] = useState(false)
   const [menuName, SetMenuName] = useState("")
   const [parentName, SetParentName] = useState("")
   const [LocationCode, setLocationCode] = useState("")
   const [LogUserType, setLogUserType] = useState("")
   const [printoptionShow, setprintoptionShow] = useState(false)
 
   /**********Loading Alert */
   const [loadingAlert, SetLoadingAlert] = useState(false)
   const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
   /**********End Loading Alert */
 
   //* Footer Total values */
   const [lineDisc, SetLineDisc] = useState("0.00")
   const [GrossTotal, SetGrossTotal] = useState("0.00")
   const [txDiscount, SetTxDiscount] = useState("0.00")
   const [txDiscountAmt, SetTxDiscountAmt] = useState("0.00")
   const [txAddition, SetTxAddition] = useState("0.00")
   const [txDeduction, SetTxDeduction] = useState("0.00")
   const [txTaxInc, SetTxTaxInc] = useState("0.00")
   const [txTaxExc, SetTxTaxExc] = useState("0.00")
   const [txNetAmount, SetTxNetAmount] = useState("0.00")
   const [txRefAmount, SetRefAmount] = useState("0.00")
   const [bomFromValue, setBomFromValue] = useState(0)
   const [bomToValue, setBomToValue] = useState(0)
   //* End Footer Total Values */
 
   //*** useState for hold Header Values */
   const [customerSelect, SetCustomerSelect] = useState("")
   const [customerSelectName, SetCustomerSelectName] = useState("")
   const [bomSelect, SetBomSelect] = useState("")
   const [bomSelectName, SetBomSelectName] = useState("")
   const [proSelect, SetProSelect] = useState("")
   const [proSelectName, SetProSelectName] = useState("")
   const [baseProduct, SetBaseProduct] = useState("")
   const [supplierSelect, SetSupplierSelect] = useState("")
   const [supplierSelectName, SetSupplierSelectName] = useState("")
   const [supplierContribution, SetSupplierContribution] = useState(0)
   const [skipSupplierApproval, SetSkipSupplierApproval] = useState(false)
   const [fromLocationSelect, SetFromLocationSelect] = useState("")
   const [toLocationSelect, SetToLocationSelect] = useState("")
   const [deliLocationSelect, SetDeliLocationSelect] = useState("")
   const [saleAssistantSelect, SetSalesAssistantSelect] = useState("")
   const [saleAssistantSelectName, SetSalesAssistantSelectName] = useState("")
   const [priceModeSelect, SetPriceModeSelect] = useState("")
   const [refTypeSelected, SetRefTypeSelected] = useState("")
   const [glBatchNo, SetGLBatchNo] = useState("")
 
   const [processStat, SetProcessStat] = useState("")
   const [fullyUsd, SetFullyUsd] = useState("")
   const [cancelDoc, SetCancelDoc] = useState("")
 
   const [docNo, SetDocno] = useState("")
   const [RefCode, SetRefCode] = useState("")
   const [docNoDisable, SetDocNoDisable] = useState(false)
   const [disabledPriceMode, SetdisabledPriceMode] = useState(false)
   const [disabledRemarks, SetdisabledRemarks] = useState(false)
   const [disabledCustomer, SetdisabledCustomer] = useState(false)
   const [disabledDate, SetdisabledDate] = useState(false)
   const [dateDisableFields, SetDateDisableFields] = useState({
       txtDate: false,
       validDate: false,
       validFromDate: false,
       validToDate: false,
   })

   const [disabledSupplier, SetdisabledSupplier] = useState(false)
   const [disabledRefType, SetdisabledRefType] = useState(false)
   const [disabledSA, SetdisabledSA] = useState(false)
   const [disabledFL, SetdisabledFL] = useState(false)
   const [disabledTL, SetdisabledTL] = useState(false)
   const [disabledDL, SetdisabledDL] = useState(false)
   const [disabled, Setdisabled] = useState(false)
   const [remarks1, SetRemarks1] = useState("")
   const [remarks2, SetRemarks2] = useState("")
   const [referenceRemark, SetReferenceRemark] = useState("")
   const [summaryRemarksList, setSummaryRemarksList] = useState([])
   const [detailReasonTypeList , setdetailReasonTypeList] = useState([])
   const [txndate, SetTxnDate] = useState("")
   const [validDay, setValidDay] = useState("")
   const [TaxDetails, SetTaxDetails] = useState([])
   const [addNew, SetAddNew] = useState(true)
   const [generalFields , setGeneralFields] = useState({
    disableConsignment: false,
    autoOrderShow:false,
    autoOrderStartDate: "",
    autoOrderEndDate: "",
    autoOrderQty: 0,
    gpPopupShow: false,
    gpVarianceList: [],
    gpVerifying: false,
   })
 
   var transactionProcess = 0
   const [txnProcess, SetTxnProcess] = useState(0)
 
   const [fromLocations, SetFromLocation] = useState([])
   const [toLocations, SetToLocation] = useState([])
 
   const [validFromDate, SetValidFromDate] = useState("")
   const [validToDate, SetValidToDate] = useState("")
 
   var recCount = 0
 
   const [DataRow, SetDataRow] = useState(transOBJ)
   const [RefDataRow, SetRefDataRow] = useState([])
   const [taxTable, SetTaxtTable] = useState([])
   const [newTaxTable, setNewTaxTable] = useState([])
 
   const [DisableDet, SetDisableDet] = useState(false)
 
 
   const [taxProductCodes, setTaxProductCodes] = useState([])
 
   const [RemHedDataRow, SetRemHedDataRow] = useState([{ id: 1, strRHED_REMARK: "" }])
 
   // set desable or editable
   const [modal_xlarge, setmodal_xlarge] = useState(false)
   const [Suppmodal_xlarge, setSuppmodal_xlarge] = useState(false)
   const [Cusmodal_xlarge, setCusmodal_xlarge] = useState(false)
   const [Bommodal_xlarge, setBommodal_xlarge] = useState(false)
   const [Promodal_xlarge, setPromodal_xlarge] = useState(false)
   const [SAmodal_xlarge, setSAmodal_xlarge] = useState(false)
   const [Refmodal_xlarge, setRefmodal_xlarge] = useState(false)
   const [show, setShow] = useState(false)
   const [AlertMsg, setAlertMsg] = useState("")
   const [AlertColor, setAlertColor] = useState("")
   const [saveBtnEnable, setSaveEnable] = useState(true)
 
   const [crEnable, setCrEnable] = useState(false)
   const [crBy, setCrBy] = useState("")
   const [mdBy, setMdBy] = useState("")
   const [crDate, setCrDate] = useState("")
   const [mdDate, setMdDate] = useState("")
   const [menuCode, SetMenuCode] = useState("")
   const [Reason, setReason] = useState("")
   const [reasonForDetails, setReasonForDetails] = useState("")
 
   //Alert Parameter
   const [sweetAlertShow, setsweetAlertShow] = useState(false)
   const [showCancel, setshowCancel] = useState(true)
   const [AlertDescription, setAlertDescription] = useState(false)
   const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
   const [printDoc, setPrintDoc] = useState("")
   const [btnYes, setBtnYes] = useState("Yes")
 
   //User Permission related usestates
   const [permissionAlertShow, setPermissionAlertShow] = useState(false)
   const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
   const [permissionReasonShow, setPermissionReasonShow] = useState(true)
   const [requiredReason, setRequiredReason] = useState(false)
   const [permissionName, setPermissionName] = useState("")
   const [permissionPassword, setPermissionPassword] = useState("")
   const [permissionNameDisable, setPermissionNameDisable] = useState(false)
 
   //user specialPermission related usestates
   const [specialPermissionAlertShow, setSpecialPermissionAlertShow] = useState(false)
   const [specialPermissionAlertTitle, setSpecialPermissionAlertTitle] = useState("")
   const [specialPermissionName, setSpecialPermissionName] = useState("")
   const [specialPermissionPassword, setSpecialPermissionPassword] = useState("")
   const [specialPermissionCode, setSpecialPermissionCode] = useState(0)
   const [specialPermissonMenCode, setSpecialPermissonMenCode] = useState("")
 
   const [helpUrl, setHelpUrl] = useState("")
 
   //Payment
   const [totalPayValue, SetTotalPayValue] = useState(0.00)
   const [PayDataRow, SetPayDataRow] = useState(PaymentObj)
 
   //Remote
   const [remoteData, SetRemoteData] = useState([])
   const [remoteRequest, SetRemoteRequest] = useState([])
 
   const [userName, setUserName] = useState("")
 
   //**Permission Granted Alert usestates */
   const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
   const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
   const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")
   const [uc, setUc] = useState(false)
   const [mobileToggle, setMobileToggle] = useState(false)
   const [shelfDataSet, setShelfDataSet] = useState([])
   const [refStockFreeze, setRefStockFreeze] = useState(false)
 
   const [customActiveTab, setcustomActiveTab] = useState("1")
 
   const [selectedAttachFiles, setSelectedAttachFiles] = useState([])
   const [attachFileNames, setAttachFileNames] = useState([]);
   const [clearAttachmentEdit, setClearAttachmentEdit] = useState(false)
   const [mobileManDetailPopup, setMobileManDetailPopup] = useState({
     isOpen: false,
     toggle: () => {
       setMobileManDetailPopup({ ...mobileManDetailPopup, isOpen: false })
     },
     onRowSelected: (item, refTypeSelected, fromLocationSelect, gridData) => {
       getMobileManDetails(item, refTypeSelected, fromLocationSelect, gridData)
     },
     items: [],
   })
   const [isSaving, setIsSaving] = useState(false)
 
   const [mobileMan , setMobileMan] = useState({
    user: "",
    remark: "",
   })

   

   //**Show Approval in Save */
   const [AppWindowShow, setAppWindowShow] = useState(false);
   //**end Show Approval in Save */
 
   const [TaxLineRemarks, SetTaxLineRemarks] = useState([{ LineNo: 1, remark: '', key: 0 }])
 
 
   //Excel upload related states
   /**
     1. Pass the file to readExcel function
     2. readExcel function will return a promise
     3. Inside promise we are setting the excelItems state
 
    */
 
 
   /*
     1. Each time excelItems state changes, we are modifying the excelItems according to our requirement.
     2. Modified items will sent to valida function , GetValidateExcelProducts .
     3. GetValidateExcelProducts will return validated products.
     4. Then we chcecck the validated products status.
     5. If status is true, then we are calling the line amount calculation function.
     6. If supplier is selected we get supplier tax using GetSupplierTax function.
     7. Then we are calling the tax calculation function, CalculateTaxFrom.
   */
 
 
   const handleFileChange = async (e) => {
 
     const file = e.target.files[0]
 
     if (!file) {
       return
     }
 
     e.target.value = '';
 
     if (fileInputRef.current) {
       fileInputRef.current.value = '';
     }
 
 
     if (txn.strTX_REFTYPES != "" && txn.strTX_REFTYPES != null && txn.intTX_REFOPTIONAL == 0) {
       displayAlertMessage("danger", `Reference Document is not allowed for Excel Upload !`)
       return
     }

     if(txn.strTX_REFTYPES != "" && txn.strTX_REFTYPES != null && RefCode != "" && RefCode != null && txn.intTX_REFOPTIONAL == 1){
        displayAlertMessage("danger", `Reference Document is not allowed for Excel Upload !`)
        return
     }
 
     if (fromLocationSelect == "") {
       displayAlertMessage("danger", `Please Select From Location before Excel Upload !`)
       return
     }
 
     if (txn.strTX_DESTINV != 'N' && txn.strTX_DESTINV != '') {
       if (toLocationSelect == "") {
         displayAlertMessage("danger", `Please Select To Location before Excel Upload !`)
         return
       }
     }
 
     if (txn.intTX_SUPPLIER == 1 && supplierSelect == "") {
       displayAlertMessage("danger", `Please Select Supplier before Excel Upload !`)
       return
     }
 
     if (txn.intTX_SAVEINVOICE == 1 && customerSelect == "") {
       displayAlertMessage("danger", `Please Select Customer before Excel Upload !`)
       return
     }
 
     if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect == "") {
       displayAlertMessage("danger", `Please Select Price Mode before Excel Upload !`)
       return
     }
 
 
     try {
 
       SetLoadingAlert(true)
       SetLoadingAlerttitle("Excel Uploading...")
 
       const dataSet = await handleExcelUpload(file, fromLocationSelect, supplierSelect, customerSelect, type, priceModeSelect)
 
       if (dataSet.success == false) {
         displayAlertMessage("danger", dataSet.message)
         return
       }
 
       if (dataSet.status != "0") {
         setProductErrorData(dataSet.data)
         setProductErrorToggle(true)
       } else {
 
         //check if there are values with decimal points where isDecimal is 0 check dcDET_CASEQTY and dcDET_UNITQTY
         var isDecimalItem = dataSet.detailTable.filter((item, index) => {
           return item.isDecimal == 0 && (item.dcDET_CASEQTY % 1 != 0 || item.dcDET_UNITQTY % 1 != 0 || item.dcDET_FCASEQTY % 1 != 0 || item.dcDET_FUNITQTY % 1 != 0)
         })
 
         if (isDecimalItem.length > 0) {
           setshowCancel(false)
           setsweetAlertShow(true)
           setAlertDescription("There were some values with decimal points where decimal is not allowed and system has rounded them to the nearest whole number")
           setAlertConfirmOption(13)
           setBtnYes("Ok")
         }
 
         var modifiedDetailTable = dataSet.detailTable.map((item, index) => {
 
           item.dcDET_ACOST = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
           item.dcDET_ACOST_OLD = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
           item.dcDET_APRICE = parseFloat(item.dcDET_APRICE).toFixed(txnDecimalAmt)
           item.dcDET_BALQTY = parseFloat(item.dcDET_BALQTY).toFixed(txnDecimalQty)
           item.dcDET_CASEQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_CASEQTY).toFixed(0) : parseFloat(item.dcDET_CASEQTY).toFixed(txnDecimalQty)
           item.dcDET_CS = parseFloat(item.dcDET_CS).toFixed(0)
           item.dcDET_DISCPER = parseFloat(item.dcDET_DISCPER).toFixed(txnDecimalAmt)
           item.dcDET_DISCAMT = parseFloat(item.dcDET_DISCAMT).toFixed(txnDecimalAmt)
           item.dcDET_FCASEQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_FCASEQTY).toFixed(0) : parseFloat(item.dcDET_FCASEQTY).toFixed(txnDecimalQty)
           item.dcDET_FUNITQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_FUNITQTY).toFixed(0) : parseFloat(item.dcDET_FUNITQTY).toFixed(txnDecimalQty)
           item.dcDET_OAPRICE = parseFloat(item.dcDET_OAPRICE).toFixed(txnDecimalAmt)
           item.dcDET_OCPRICE = parseFloat(item.dcDET_OCPRICE).toFixed(txnDecimalAmt)
           item.dcDET_OSPRICE = parseFloat(item.dcDET_OSPRICE).toFixed(txnDecimalAmt)
           item.dcDET_CPRICE = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
           item.dcDET_SPRICE = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
           item.dcDET_SPRICE_OLD = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
           item.dcDET_CPRICE_OLD = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
           item.dcDET_SYSQTY = parseFloat(item.dcDET_SYSQTY).toFixed(txnDecimalQty)
           item.dcDET_UNITQTY = item.isDecimal == 0 ? parseFloat(item.dcDET_UNITQTY).toFixed(0) : parseFloat(item.dcDET_UNITQTY).toFixed(txnDecimalQty)
           item.disable = true
           return item;
         })
 
         if (dataSet.taxTable.length > 0 && txn.inTX_TAX == 1) {
           await ModifyTaxGridFromExcel(txnTaxTypes, dataSet.taxTable, modifiedDetailTable, SetTaxtTable, txnDecimalAmt)
         }
 
         await TotalLineAmtCalcualtion(modifiedDetailTable)
 
       }
     } catch (error) {
       console.log("error", error)
     }finally{
        SetLoadingAlert(false)
     }
 
 
 
   };
 
 
 
   /*
     1. Each time taxTable state changes, we are calling the TxnTotalCal function
     2. TxnTotalCal function will calculate the total amount and set the total amount to the txnTotal state
   */
   useEffect(() => {
     TxnTotalCal()
   }, [supplierContribution])
 
 
 
 
   useEffect(async () => {
 
     var obj = JSON.parse(localStorage.getItem("authUser"))
     var LogUserType = obj[2]
     setUserName(LogUserType)
     var LocationCode = obj[3]
     var CompanyCode = obj[5]
 
     SetLoadingAlert(true)
     SetLoadingAlerttitle("UI Loading...")
     try {
       var menuDetail = await getMenuDetails(window.location.pathname + "?" + type)
       var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
 
       await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log
       SetMenuCode(menu)
 
       const result = await GetHeaderReasonTypes(type)
 
       if (result.success) {
         setSummaryRemarksList(result.data)
       } else {
         setSummaryRemarksList([])
       }

       
    const detailresult = await GetDetailReasonTypes(type)

    if (detailresult.success) {
      setdetailReasonTypeList(detailresult.data)
    } else {
      setdetailReasonTypeList([])
    }

 
       SetDisableDet(false)
     } catch (error) {
       console.log("error", error)
       SetLoadingAlert(false)
     }
 
     setShow(false)
 
   }, [type])
 
 
   useEffect(async () => {
     await ClearItem()
 
     var obj = JSON.parse(localStorage.getItem("authUser"))
     var user = obj[2]
     var LoggedLocation = obj[3]
 
     SetLoadingAlert(true)
     SetLoadingAlerttitle("UI Loading...")
 
     await fetch(`${ApiURL}txn/${type}`, {
       method: "GET",
       headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${authToken}`,
       },
     }).then(Response => Response.json())
       .then(responseData => {
         SetLoadingAlert(false)
 
         if (responseData.success) {
 
           setTxn(responseData.data)
           let Data = responseData.data
           if (Data.intTX_NOTCREATABLE == 1) {
             setSaveEnable(false)
             Setdisabled(true)
             SetdisabledPriceMode(true)
             SetdisabledRemarks(true)
             SetdisabledCustomer(true)
             SetdisabledDate(true)
             SetDateDisableFields(prevState => ({
                ...prevState,
                txtDate: true,
                validDate: true,
                validFromDate: true,
                validToDate: true
              })
             )
             SetdisabledSupplier(true)
             SetdisabledRefType(true)
             SetdisabledSA(true)
             SetdisabledFL(true)
             SetdisabledTL(true)
             SetdisabledDL(true)
             SetDisableDet(true)
           } else {
             setSaveEnable(true)
             Setdisabled(false)
             SetdisabledPriceMode(false)
             SetdisabledRemarks(false)
             SetdisabledCustomer(false)
             SetdisabledDate(false)
             SetDateDisableFields(prevState => ({
                ...prevState,
                txtDate: false,
                validDate: false,
                validFromDate: false,
                validToDate: false
              })
             )
             SetdisabledSupplier(false)
             SetdisabledRefType(false)
             SetdisabledSA(false)
             SetdisabledFL(false)
             SetdisabledTL(false)
             SetdisabledDL(false)
             SetDisableDet(false)
           }
 
           if (Data.intTX_CHKPOSEOD == 1) {
             let date = new Date()
             let SysDate = new Date(Data.dtSETUP_ENDDATE)
 
             if (SysDate >= date) {
               setSaveEnable(false)
               Setdisabled(true)
               SetdisabledPriceMode(true)
               SetdisabledRemarks(true)
               SetdisabledCustomer(true)
               SetdisabledDate(true)
               SetDateDisableFields(prevState => ({
                ...prevState,
                txtDate: true,
                validDate: true,
                validFromDate: true,
                validToDate: true
              })
             )
               SetdisabledSupplier(true)
               SetdisabledRefType(true)
               SetdisabledSA(true)
               SetdisabledFL(true)
               SetdisabledTL(true)
               SetdisabledDL(true)
               SetDisableDet(true)
               setshowCancel(false)
               setBtnYes("Ok")
               setAlertDescription("Please complete the EOD before proceed !")
               setAlertConfirmOption(3)
               setsweetAlertShow(true)
             }
           }
           if (Data.intTX_FROMLOCSETUP == 1) {
             SetdisabledFL(true)
           }
           if (Data.intTX_TOLOCSETUP == 1) {
             SetdisabledTL(true)
           }
 
 
           let valdate = txndate
 
           if (Data.intTX_VALIDDAYS > 0) {
             if (valdate) {
               var txnDat = new Date(txndate)
               var tomorrow = new Date(txndate)
               tomorrow.setDate(txnDat.getDate() + parseInt(Data.intTX_VALIDDAYS))
               setValidDay(tomorrow.toISOString().slice(0, 10))
             } else {
               let dates = new Date()
               var tomorrow = new Date()
               tomorrow.setDate(dates.getDate() + parseInt(Data.intTX_VALIDDAYS))
               setValidDay(tomorrow.toISOString().slice(0, 10))
             }
           }
 
           if (parseInt(Data.intTX_VALIDTILLDATE) > 0) {
 
             let currentDate = new Date()
             let validTillDate = new Date()
             //add given dat4es to current date
             validTillDate.setDate(currentDate.getDate() + parseInt(Data.intTX_VALIDTILLDATE))
 
             SetValidFromDate(currentDate.toISOString().slice(0, 10))
             SetValidToDate(validTillDate.toISOString().slice(0, 10))
 
           }
         } else {
           setshowCancel(false)
           setBtnYes("Ok")
           setAlertDescription("Please contact your administrator , This transaction is not available !")
           setAlertConfirmOption(3)
           setsweetAlertShow(true)
         }
 
       }).catch(error => {
         console.log("error", error)
         SetLoadingAlert(false)
       })
 
     var fromLoc = await getTxnLocations(type, user, 1, LoggedLocation)
     SetFromLocation(fromLoc)
     var findLoggedLocation = fromLoc.find(x => x.value == LoggedLocation)
 
     //check if findLoggedLocation is undefined
     if (findLoggedLocation != undefined) {
       SetFromLocationSelect(LoggedLocation)
     } else {
       SetFromLocationSelect("")
     }
 
     SetToLocationSelect("") //set to location to empty
 
     var toLoc = await getTxnLocations(type, user, 0, LoggedLocation)
     SetToLocation(toLoc)
 
 
     const monthendResutl = await GetMonthend(LoggedLocation)
     setCurrentRunningMonth(monthendResutl.data.month)
     setCurrentRunningYear(monthendResutl.data.year)
 
   }, [type])
 
 
   useEffect(async () => {
 
     if (inv.length > 1) {
       setTimeout(() => {
         getData(inv)
         SetDocNoDisable(true)
         setSaveEnable(false)
         Setdisabled(true)
         SetdisabledPriceMode(true)
         SetdisabledRemarks(true)
         SetdisabledCustomer(true)
         SetdisabledDate(true)
         SetDateDisableFields(prevState => ({
            ...prevState,
            txtDate: true,
            validDate: true,
            validFromDate: true,
            validToDate: true
          })
          )
         SetdisabledSupplier(true)
         SetdisabledRefType(true)
         SetdisabledSA(true)
         SetdisabledFL(true)
         SetdisabledTL(true)
         SetdisabledDL(true)
       }, 1000);
     }
 
   }, [inv, txn])
 
 
 
 
   const toggleCustom = tab => {
     setcustomActiveTab(tab)
     /*if (customActiveTab !== tab) {
       setcustomActiveTab(tab)
     }*/
   }
 
 
   /*Supplier search toggle */
   function SupplierSearch_Tog() {
     setSuppmodal_xlarge(!Suppmodal_xlarge)
     removeBodyCss()
   }
 
   /*Customer search toggle*/
   function CustomerSearch_Tog() {
     setCusmodal_xlarge(!Cusmodal_xlarge)
     removeBodyCss()
   }
 
   function BomSearch_Tog() {
 
     if (proSelect == "") {
       setAlertDescription("Please Select Finish Product First")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       return
     }
 
     if (fromLocationSelect == "") {
       setAlertDescription("Please Select Location !")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       return
     }
 
     setBommodal_xlarge(!Bommodal_xlarge)
     removeBodyCss()
 
   }
 
   function ProSearch_Tog() {
     setPromodal_xlarge(!Promodal_xlarge)
     removeBodyCss()
   }
 
   function SASearch_Tog() {
     setSAmodal_xlarge(!SAmodal_xlarge)
     removeBodyCss()
   }
 
   //** Add details table rows */
   const AddRow = async () => {
 
     //check if transaction is approved then can not add new products to approved transaction
 
     if (remoteData.filter(item => item.isCurrent == true).some(item => item.intTX_APPROVE == 1)) {
       displayAlertMessage("danger", `Can not add new products to approved transaction !`)
       return
     }
 
     // if (remoteData.length > 0) {
     //   displayAlertMessage("danger", `Can not add new products to approved transaction !`)
     //   return
     // }
 
     if (txn.intTX_BOM == 1) {
       return
     }
 
     const modifiedRows = [...DataRow] //copy of original rows array from state
 
     if (txn.intTX_ITEMCHANGE == 1) {
       return false
     }
 
     let isEmptyRow = -1
     let emptyRow = modifiedRows.findIndex(row => row.strDET_PROCODE == "") //check if any empty row is available in table and get index
 
     if (emptyRow != -1) {
       return emptyRow
     }
 
     // var newRowID = parseInt(modifiedRows[modifiedRows.length - 1].id) + 1 //get last row id and add 1
 
 
     var newRowID;
 
     if (modifiedRows.length > 0) {
       // newRowID = parseInt(modifiedRows[modifiedRows.length - 1].id, 10) + 1;
       // Use Math.max to find the maximum 'id' value in the array
       let maxId = Math.max(...modifiedRows.map(row => parseInt(row.id, 10)));
 
       // Add 1 to the maximum 'id' value to get the new ID
       newRowID = maxId + 1;
     } else {
 
       newRowID = 1; // For example, start from 1 if there are no existing rows
     }
 
     //create new empty row

     //copy new newRow from transOBJ object

     var newRow = {...transOBJ[0]}

     newRow.id = newRowID //add new id to the new row
     modifiedRows.push(newRow) //add new row to the array
 
     SetDataRow(modifiedRows) //update state with new array
 
     var lineRemarks = [...TaxLineRemarks] // copy of original array of line remarks
     lineRemarks.push({ LineNo: newRowID, remark: '', key: 0 }) //add new row to the array
     SetTaxLineRemarks(lineRemarks) //update state with new array
 
     return isEmptyRow //return index of empty row
   }
 
 
   const AddPayRow = () => {
     const modifiedRows = [...PayDataRow]
 
     const hasEmptyRow = modifiedRows.find(x => x.Paycode === "" || x.Paydesc === "");
 
     if (hasEmptyRow) {
       return false;
     }
 
     modifiedRows.push({
       id: parseInt(modifiedRows[modifiedRows.length - 1].id + 1),
       Paycode: "",
       PayCodeDisable: false,
       Paydesc: "",
       PayDetcode: "",
       PayDetcodeDesable: true,
       PayDetName: "",
       PayAmount: 0,
       PayAmountDisable: true,
       AccountCode: "",
       AccountCodeDisable: true,
       ExpDate: "",
       ExpDateDisable: true
     })
     SetPayDataRow(modifiedRows)
   }
 
 
 
   /*
   1. This function will remove a row from the table
   2. It will also remove the corresponding row from tax table
   3. It will also remove the corresponding row from line remarks table
   4. It will also remove the corresponding row from line attachments table
   */
 
   const RemoveRow = async (id, code, desc) => {
 
     //check if transaction is approved then can not remove products from approved transaction
 
     if (remoteData.filter(item => item.isCurrent == true).some(item => item.intTX_APPROVE == 1)) {
       displayAlertMessage("danger", `Can not remove products from approved transaction !`)
       return
     }
 
 
    try{

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Removing Row...")

      let filteredDataRows = DataRow.filter(x => x["id"] != id)
    
      if (filteredDataRows.length == 0) {
        filteredDataRows = [...transOBJ]
      }

  
      if (RefCode == "" && refTypeSelected == "" && RefDataRow.length > 0) {
  
        //update id and keep old id
        const updatedDataRows = filteredDataRows.map((item, index) => {
          return {
            ...item,
            id: index + 1,
            oldId: item.id
          }
        })

        //update tax table with new data

        const updatedTaxTable = []
        const updatedTaxLineRemarks = []

        updatedDataRows.forEach((item, index) => {

          const taxRow = taxTable.filter(x => x.detailRowID == item.oldId && x.proCode == item.strDET_PROCODE)

          if (taxRow && taxRow.length > 0) {
            taxRow.forEach((row) => {
              updatedTaxTable.push({
                ...row,
                id: index + 1,
                detailRowID: item.id
              })
            })
          }


          const lineRemark = TaxLineRemarks.filter(x => x.LineNo == item.oldId)

          if (lineRemark) {
            lineRemark.forEach((remark, lineIndex) => {
              updatedTaxLineRemarks.push({
                ...remark,
                LineNo: item.id
              })
            })
          }

        })

        SetDataRow(updatedDataRows)
        SetTaxLineRemarks(updatedTaxLineRemarks)

        TxnTotalCal(updatedDataRows, updatedTaxTable)

      } else {
        SetDataRow(filteredDataRows)
        TxnTotalCal(filteredDataRows)
        SetTaxLineRemarks(TaxLineRemarks.filter(x => x["LineNo"] != id))
      }

    }catch(error){
      console.log("error", error)
    }finally{
      setTimeout(() => {
        SetLoadingAlert(false)
      }, 500);
    }
    
   }
 
 
   const [tabList, SetTabList] = useState([
     {
       text: "Transaction",
       icon: "fas fa-home",
       tabID: "1",
       onClick: () => {
         toggleCustom("1")
       },
     },
     {
       text: "Details",
       icon: "far fa-user",
       tabID: "2",
       onClick: () => {
         toggleCustom("2")
       },
     },
     {
       text: "Remarks",
       icon: "far fa-user",
       tabID: "3",
       onClick: () => {
         toggleCustom("3")
       },
     },
     {
       text: "Attachments",
       icon: "far fa-user",
       tabID: "4",
       onClick: () => {
         toggleCustom("4")
       },
     },
 
   ])
 
   /*{
     text: "SubDocs",
     icon: "far fa-user",
     tabID: "5",
     onClick: () => {
       toggleCustom("5")
     },
   }*/
 
   function tog_xlarge() {
     SetDocNoDisable((prev) => {
       if (!prev) {
         setmodal_xlarge(!modal_xlarge)
         removeBodyCss()
       }
       return prev
     })
   }
 
   function toggleApp() {
     setAppWindowShow(!AppWindowShow)
     if (AppWindowShow) {
       ClearItem()
       setAlertDescription("Do you wish to print this document ?")
       setAlertConfirmOption(6)
       setsweetAlertShow(true)
     }
     removeBodyCss()
   }
 
   function tog_xlargeM() {
     setmodal_xlargeM(!modal_xlargeM)
     removeBodyCss()
   }
 
   function Reftog_xlarge() {
     setRefmodal_xlarge(!Refmodal_xlarge)
     removeBodyCss()
   }
 
   //removebodyCss function
   function removeBodyCss() {
     document.body.classList.add("no_padding")
   }
 
   //Calculate Payamount
   function TotalPayCalculation(dataset = []) {
 
     var newPayment = dataset.length > 0 ? dataset : PayDataRow
 
     let LineNetAmount = 0
     newPayment.map((item, index) => {
       LineNetAmount = parseFloat(LineNetAmount) + parseFloat(item.PayAmount)
     })
 
     SetTotalPayValue(parseFloat(LineNetAmount).toFixed(txnDecimalAmt))
 
     return parseFloat(LineNetAmount).toFixed(txnDecimalAmt);
   }
 
   //* Get Data for Single Record */
   const getData = async (runno) => {
     if (runno != "") {
 
       var barcodeElement = document.getElementById("ScanBarCode");
       if (barcodeElement) {
         barcodeElement.value = "";
       }
 
       var obj = JSON.parse(localStorage.getItem("authUser"))
       const logLocationCode = obj[3]
 
       try {
 
         SetLoadingAlert(true)
         SetLoadingAlerttitle("Loading Data...")
         const response = await fetch(`${ApiURL}txn/single/${type}/${runno}/${txn.intTX_SAVEINVOICE ? txn.intTX_SAVEINVOICE : 0}/${urlLocation != "" ? urlLocation : logLocationCode}`, {
           method: "GET",
           headers: {
             "Content-Type": "application/json",
             Authorization: `Bearer ${authToken}`,
           },
         });
 
 
         if (response.ok) {
 
           const responseData = await response.json();
           const Data = responseData.data;
 
           if (responseData.success) {
             SetAddNew(false)
             SetDocno(Data.strHED_RUNNO)
             SetRefTypeSelected(Data.strHED_REFTYPE)
             setPrintDoc(Data.strHED_RUNNO) //set print doc
             SetFromLocationSelect(Data.strHED_LOCFROM)
             SetProcessStat(Data.blHED_PROCESSED == true ? "Processed" : "Unprocessed")
             SetFullyUsd(Data.blHED_FULLYUSED == true ? "/Fully Utilized" : "")
             SetCancelDoc(Data.blHED_CANCELLED == true ? "Cancelled Document !" : "")
             SetToLocationSelect(Data.strHED_LOCTO)
             SetDeliLocationSelect(Data.strHED_LOCDEL)
             SetCustomerSelect(Data.strHED_CUSCODE)
             SetSalesAssistantSelect(Data.strHED_SACODE)
             SetSalesAssistantSelectName(Data.strSA_FULLNAME)
             SetSupplierSelect(Data.strHED_SUPCODE)
 
             const response = await getTransactionTax(txn.intTX_TAXH_CODE, Data.strHED_SUPCODE != "" ? Data.strHED_SUPCODE : Data.strHED_CUSCODE, type)
             setTxnTaxTypes(response.data)
             
             if(Data.blHED_PROCESSED){
              setCalTax(false)
             }

 
             SetGLBatchNo(Data.strHED_GLBATCH)
             setClearAttachmentEdit(prev => !prev)
 
             if (txn.intTX_BOM == 1) {
               SetProSelect(Data.strHED_SUPCODE)
               SetProSelectName(Data.strSM_NAME)
               SetBomSelect(Data.strHED_CUSCODE)
               SetBomSelectName(Data.strCM_FULLNAME)
               SetBaseProduct(Data.objTXN_DETSAVE ? Data.objTXN_DETSAVE[1].strDET_PROCODE : "")
             }
 
             setCrBy(Data.strCR_BY);
 
             SetValidFromDate(Data.dtHED_VALIDFROMDATE.slice(0, 10) == "1990-01-01" ? "" : Data.dtHED_VALIDFROMDATE.slice(0, 10))
             SetValidToDate(Data.dtHED_VALIDTODATE.slice(0, 10) == "1990-01-01" ? "" : Data.dtHED_VALIDTODATE.slice(0, 10))
 
             setTimeout(async () => {//get reference transaction data
               SetRefCode(Data.strHED_REFNO)
               if (Data.strHED_REFTYPE != "") {
                 const refTxnData = await GetTxn(Data.strHED_REFTYPE)
                 setRefStockFreeze(refTxnData.intTX_STOCKFREEZE == 1 ? true : false)
 
                 var refData = await GetReferenceDoc(type, Data.strHED_REFTYPE, Data.strHED_LOCFROM, Data.strHED_LOCTO, Data.strHED_REFNO)
                 if (refData.isSuccess) {
                   SetRefDataRow(refData.data)
                 }
               }
             }, 2)
 
    
             SetLineDisc(0.0)

             SetTxnDate(Data.dtHED_TXNDATE.slice(0, 10))
             SetPriceModeSelect("")

             SetRemarks1(Data.strHED_REF1)
             SetRemarks2(Data.strHED_REF2)
 
             SetSupplierSelectName(Data.strSM_NAME)
             SetCustomerSelectName(Data.strCM_FULLNAME)
             SetPriceModeSelect(Data.strHED_PRICEMODE)
             let lineRem = Data.objTXN_DETREMDETSAVE
 
             let setLineData = lineRem.map(item => ({
               LineNo: item.intRDET_LINENO,
               remark: item.strRDET_REMARK,
               key: item.intRDET_REMLINE
             }));
 
             SetTaxLineRemarks(setLineData)
 
 
             //Display Tax
             await ModifyTaxGrid(Data.objTXN_DETTAXSAVE, Data.objTXN_DETSAVE, SetTaxtTable, txnDecimalAmt)
 
             SetRemHedDataRow([])
             SetPayDataRow([])
             SetRemoteData(Data.objApprovalRequest)
             SetDisableDet(true)
 
 
             let dataset = await getSubDocs(Data.objTXN_DETSUBDOCS)
             if (dataset.status == 1) {
               setSubDocs(dataset.subdocsResponse)
             }
 
 
             setTimeout(async() => {
               const modifiedTable = await modifyGridTable(Data.objTXN_DETSAVE,txnDecimalQty,txnDecimalAmt,txn )
               SetDataRow(modifiedTable);

               SetTxNetAmount(Data.decHED_NETAMT)
               SetRefAmount(Data.decHED_NETAMT)
               SetGrossTotal(Data.decHED_GROSSAMT)
               SetTxAddition(Data.decHED_ADDAMT)
               SetTxDeduction(Data.decHED_DEDAMT)
               SetTxDiscount(Data.decHED_DISCPER)
               SetTxTaxExc(Data.decHED_ETAXAMT)
               SetTxTaxInc(Data.decHED_ITAXAMT)

               let payDat = Data.objPaymentRes
 
               let PaymentRaw = payDat.map((item, index) => ({
                 id: index + 1,
                 Paycode: item.strPHCode,
                 Paydesc: item.strPHDesc,
                 PayDetcode: item.strPDCode,
                 PayDetName: item.strPDDesc,
                 PayAmount: parseFloat(item.dcAmount).toFixed(txnDecimalAmt),
                 AccountCode: item.strRefNo,
                 ExpDate: item.dtPayTypeDate,
               }));
 
 
               const newAttachList = Data.objTXN_DETATTHEDSAVE.map((item, index) => ({
                 lineNo: item.intAHED_LINENO,
                 fileName: item.strAHED_FILEPATH,
               }))
               setSelectedAttachFiles([])
               setAttachFileNames(newAttachList)
               SetPayDataRow(PaymentRaw)
               TotalPayCalculation(PaymentRaw)
               SetRemHedDataRow(Data.objTXN_DETREMHEDSAVE)
 
               // SetRemoteData(Data.objApprovalRequest)
 
               SetDocNoDisable(true)
               setSaveEnable(false)
               Setdisabled(true)
               SetdisabledPriceMode(true)
               SetdisabledRemarks(true)
               SetdisabledCustomer(true)
               SetdisabledDate(true)
               SetDateDisableFields(prevState => ({
                ...prevState,
                txtDate: true,
                validDate: true,
                validFromDate: true,
                validToDate: true
                })
              )
               SetdisabledSupplier(true)
               SetdisabledRefType(true)
               SetdisabledSA(true)
               SetdisabledFL(true)
               SetdisabledTL(true)
               SetdisabledDL(true)
 
               setGeneralFields(prev => ({
                ...prev,
                disableConsignment: true
              }))

               SetTabList([
                 {
                   text: "Transaction",
                   icon: "fas fa-home",
                   tabID: "1",
                   onClick: () => {
                     toggleCustom("1")
                   },
                 },
                 {
                   text: "Details",
                   icon: "far fa-user",
                   tabID: "2",
                   onClick: () => {
                     toggleCustom("2")
                   },
                 },
                 {
                   text: "Remarks",
                   icon: "far fa-user",
                   tabID: "3",
                   onClick: () => {
                     toggleCustom("3")
                   },
                 },
                 {
                   text: "Attachments",
                   icon: "far fa-user",
                   tabID: "4",
                   onClick: () => {
                     toggleCustom("4")
                   },
                 },
                 {
                   text: "Approval",
                   icon: "far fa-user",
                   tabID: "6",
                   onClick: () => {
                     toggleCustom("6")
                   },
                 }
               ])
             }, 1)
 
 
             if (Data.strHED_SUPCODE != "") {
               const { success, data, message } = await GetSupplierDetails(Data.strHED_SUPCODE, type)
               if (success) {
                 SetSupplierContribution(data.contribution)
                 SetSkipSupplierApproval(data.skipApproval)
               } else {
                 SetSupplierContribution(0)
                 SetSkipSupplierApproval(false)
               }
             }
 
             /*  {
                 text: "SubDocs",
                 icon: "far fa-user",
                 tabID: "5",
                 onClick: () => {
                   toggleCustom("5")
                 },
               },*/
 
             SetLoadingAlert(false)
 
           } else {
             SetLoadingAlert(false)
             SetDocno("")
             ClearItem()
             displayAlertMessage("danger", responseData.msg)
             return
           }
         } else {
           SetLoadingAlert(false)
           SetDocno("")
           ClearItem()
           displayAlertMessage("danger", "No Record Found !")
           return
         }
       } catch (error) { //error handling
         SetLoadingAlert(false)
         SetDocno("")
         ClearItem()
         displayAlertMessage("danger", error)
         return
       }
 
     }
   }
 
 
 
   //*** Get user selected row details */
   const GetSelectRow = (e, row, isSelect, rowIndex) => {
     //
     SetDocno(txn.intTX_SAVEINVOICE == 1 ? row.INVHED_INVNO : row.HED_RUNNO)
     getData(txn.intTX_SAVEINVOICE == 1 ? row.INVHED_INVNO : row.HED_RUNNO)
     SetDocNoDisable(true)
     setSaveEnable(false)
     Setdisabled(true)
     SetdisabledPriceMode(true)
     SetdisabledRemarks(true)
     SetdisabledCustomer(true)
     SetdisabledDate(true)
     SetDateDisableFields(prevState => ({
        ...prevState,
        txtDate: true,
        validDate: true,
        validFromDate: true,
        validToDate: true
      })
      )
     SetdisabledSupplier(true)
     SetdisabledRefType(true)
     SetdisabledSA(true)
     SetdisabledFL(true)
     SetdisabledTL(true)
     SetdisabledDL(true)
     /*
         setDisabledCode(true)        
         
         setCrBy(row.crby)
         setMdBy(row.mdby)
         setCrDate(row.crdate)
         setMdDate(row.mddate)
         setCrEnable(true)*/
     setmodal_xlarge(!modal_xlarge)
   }
 
   //* Get Data for Single Record */
   const getMobileData = async () => {
 
     if (refTypeSelected == "") {
       displayAlertMessage("danger", `Please Select Reference Type !`)
       return
     }
 
     if (fromLocationSelect == "") {
       displayAlertMessage("danger", `Please Select From Location !`)
       return
     }
 
     if (RefCode == "") {
       displayAlertMessage("danger", `Please Select Reference Code !`)
       return
     }
 
     const { isSuccess, data, msg } = await getMobileManDocumentDetailsUserWise(refTypeSelected, LogUserType, fromLocationSelect, RefCode, type)
     
     if (isSuccess) {
       setMobileManDetailPopup({
         ...mobileManDetailPopup,
         isOpen: true,
         items: data
       })
     } else {
       displayAlertMessage("danger", msg)
       setMobileManDetailPopup({
         ...mobileManDetailPopup,
         isOpen: false,
         items: []
       })
     }
 
 
   }
 
 
 
   const getMobileManDetails = async (item, refTxnType, fromLocation, gridData) => {
     setMobileManDetailPopup({
       ...mobileManDetailPopup,
       isOpen: false,
     })
 
     try {
       const { isSuccess, data, msg } = await getMobileManDocumentDetails(refTxnType, item.userName, fromLocation, item.documentNo, type)
 
       if (isSuccess) {
 
         const newGrid = gridData.map(item => {
           const matchedRow = data.find(r => r.deT_STOCKCODE == item.strDET_STOCKCODE && r.deT_LINENO == item.dcDET_LINENO);
           if (matchedRow) {
             item.dcDET_UNITQTY = parseFloat(matchedRow.deT_UNITQTY).toFixed(txnDecimalQty);
             item.dcDET_CASEQTY = parseFloat(matchedRow.deT_CASEQTY).toFixed(0);
           }
           return item;
         });
 
         displayAlertMessage("success", "Quantity Update Successful!")
         TotalLineAmtCalcualtion(newGrid)
       } else {
         displayAlertMessage("danger", "Something went wrong!, Please contact your administrator!")
       }
     } catch (error) {
       displayAlertMessage("danger", error)
     }
 
   }
 
 
   const TotalLineAmtCalcualtion = async (newGrid) => {
 
     var TotalCalculatedGrid = newGrid.map((FormRow, index) => {
 
       var newRow = FormRow
 
       if (FormRow.dcDET_DISCAMT.toString().includes("*")) {
         let disc = FormRow.dcDET_DISCAMT.substring(FormRow.dcDET_DISCAMT.indexOf("*") + 1, FormRow.dcDET_DISCAMT.length)
         disc = parseFloat(disc) * (parseFloat(FormRow.dcDET_CS) * parseFloat(FormRow.dcDET_CASEQTY) + parseFloat(FormRow.dcDET_UNITQTY))
 
         newRow.dcDET_DISCAMT = parseFloat(disc).toFixed(txnDecimalAmt)
       }
 
       if (txn.intTX_SHOWVAR == 1) {
         let SysVar = 0.0
         let enterQty = parseFloat(FormRow.dcDET_CASEQTY == "" ? 0 : FormRow.dcDET_CASEQTY) * parseFloat(FormRow.dcDET_CS) + parseFloat(FormRow.dcDET_UNITQTY == "" ? 0 : FormRow.dcDET_UNITQTY)
         if (txn.intTX_REFQTYCHK == 1) {
           SysVar = parseFloat(FormRow.dcDET_BALQTY) - enterQty
         } else if (txn.intTX_CHKSIH == 1) {
           SysVar = parseFloat(FormRow.dcDET_SYSQTY) - enterQty
         } else {
           SysVar = enterQty - parseFloat(FormRow.dcDET_SYSQTY)
         }
 
         newRow.dcDET_VARQTY = parseFloat(SysVar).toFixed(txnDecimalQty)
       }
       //
       let priceMode = 0
       if (txn.strTX_PRICEMODE == "C" || txn.strTX_PRICEMODE == "c") {
         priceMode = parseFloat(FormRow.dcDET_CPRICE.toString().replace(",", ""))
       } else if (txn.strTX_PRICEMODE == "S" || txn.strTX_PRICEMODE == "s") {
         priceMode = parseFloat(FormRow.dcDET_SPRICE.toString().replace(",", "")) //sell;
       } else if (txn.strTX_PRICEMODE == "A" || txn.strTX_PRICEMODE == "a") {
         priceMode = parseFloat(FormRow.dcDET_ACOST)
       } else if (txn.strTX_PRICEMODE == "P" || txn.strTX_PRICEMODE == "p") {
         priceMode = parseFloat(FormRow.dbPackPrice) / parseFloat(FormRow.dcDET_CS)
       }
 
       const cseQty = parseFloat(FormRow.dcDET_CASEQTY == "" ? 0 : parseFloat(FormRow.dcDET_CASEQTY))
       const totalCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? cseQty : cseQty * parseFloat(FormRow.dcDET_CS)
       const unitQty = parseFloat(FormRow.dcDET_UNITQTY == "" ? 0 : parseFloat(FormRow.dcDET_UNITQTY))
       const totalUnitQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? unitQty / parseFloat(FormRow.dcDET_CS) : unitQty
       const totalFreeUnit = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(FormRow.dcDET_FUNITQTY) / parseFloat(FormRow.dcDET_CS) : parseFloat(FormRow.dcDET_FUNITQTY)
       const freeCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(FormRow.dcDET_FCASEQTY) / parseFloat(FormRow.dcDET_CS) : parseFloat(FormRow.dcDET_FCASEQTY)
 
 
       let grossAmount = 0
 
       if (txn.intTX_BOM == 1) {
 
         grossAmount = parseFloat(priceMode) * (freeCaseQty)
 
       } else if (txn.intTX_PRODUCTION == 1 || txn.intTX_VERIFICATION == 1) {
         if (txn.intTX_VERIFICATION == 1) {
           grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty + parseFloat(totalFreeUnit)))
         } else {
           grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty - parseFloat(totalFreeUnit)))
         }
       } else {
         grossAmount = parseFloat(priceMode) * (totalCaseQty + totalUnitQty)
       }
 
       let NetAmount = grossAmount - ((parseFloat(FormRow.dcDET_DISCPER) * grossAmount) / 100 + parseFloat(FormRow.dcDET_DISCAMT))
 
       let grossHedAmt = GrossTotal.toString()
 
       grossHedAmt = grossHedAmt && grossHedAmt.includes(",") ? GrossTotal.replace(",", "") : GrossTotal
 
 
       newRow.dcDET_AMOUNT = parseFloat(NetAmount).toFixed(txnDecimalAmt)
 
       return newRow;
 
     })
 
     SetDataRow(TotalCalculatedGrid)
 
     return TotalCalculatedGrid;
 
   }
 
 
   const GetSupSelectRow = (e, row, isSelect, rowIndex) => {
     getSupplier(row.SM_CODE)
     setSuppmodal_xlarge(!Suppmodal_xlarge)
   }
 
   const GetCusSelectRow = (e, row, isSelect, rowIndex) => {
     getCustomer(row.CM_CODE)
     setCusmodal_xlarge(!Cusmodal_xlarge)
 
   }
 
   const GetBomSelectRow = async (e, row, isSelect, rowIndex) => {
 
     if (proSelect == "") {
       setBommodal_xlarge(!Bommodal_xlarge)
       setAlertDescription("Please Select Finish Product First")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       return
     }
 
     getSelectedBOM(row.BOM_CODE)
     setBommodal_xlarge(!Bommodal_xlarge)
 
   }
 
 
   const GetProSelectRow = (e, row, isSelect, rowIndex) => {
     getFinishPro(row.PLU_CODE)
     setPromodal_xlarge(!Promodal_xlarge)
   }
 
   const GetSASelectRow = (e, row, isSelect, rowIndex) => {
     getSalesAssist(row.SA_CODE)
     setSAmodal_xlarge(!SAmodal_xlarge)
   }
 
   const CodeOnBlur = code => {
     getData(code)
   }
 
   const GetRefSelectRow = (e, row, isSelect, rowIndex) => {
 
 
     if (txn.intTX_REFCHKPROC == 1 && row.processed == "Unprocessed") {
       SetRefCode("")
       displayAlertMessage("warning", `Selected document No. ${row.Code} is Not Processed !`)
       setRefmodal_xlarge(!Refmodal_xlarge)
       return
     }
     SetRefCode(row["Document No"])
     RefCodeOnBlur(row["Document No"])
     setRefmodal_xlarge(!Refmodal_xlarge)
 
   }
   //*** End of getSelectedRow function */
 
 
   function getGridTable(dataTable) {
     var newGrid = []
 
     dataTable.map((item, index) => {
       var newRow = item
       newRow.id = item.dcDET_LINENO
       newRow.disable = true
       newRow.dcDET_ACOST = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
       newRow.dcDET_ACOST_OLD = parseFloat(item.dcDET_ACOST).toFixed(txnDecimalAmt)
       newRow.dcDET_APRICE = parseFloat(item.dcDET_APRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_BALQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_BALQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_BALQTY).toFixed(0)
       newRow.dcDET_FBALQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FBALQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FBALQTY).toFixed(0)
       newRow.dcDET_CASEQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_CASEQTY).toFixed(0) : parseFloat(item.dcDET_CASEQTY).toFixed(0)
       newRow.dcDET_CPRICE = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_CS = parseFloat(item.dcDET_CS).toFixed(0)
       newRow.dcDET_DISCAMT = parseFloat(item.dcDET_DISCAMT).toFixed(txnDecimalAmt)
       newRow.dcDET_DISCPER = parseFloat(item.dcDET_DISCPER).toFixed(txnDecimalAmt)
       newRow.dcDET_FCASEQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FCASEQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FCASEQTY).toFixed(0)
       newRow.dcDET_FUNITQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_FUNITQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_FUNITQTY).toFixed(0)
       newRow.dcDET_OAPRICE = parseFloat(item.dcDET_OAPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_OCPRICE = parseFloat(item.dcDET_OCPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_OSPRICE = parseFloat(item.dcDET_OSPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_SPRICE = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_SYSQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_SYSQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_SYSQTY).toFixed(0)
       newRow.dcDET_UNITQTY = item.isDecimal == 1 || txn.intTX_BOM == 1 ? parseFloat(item.dcDET_UNITQTY).toFixed(txnDecimalQty) : parseFloat(item.dcDET_UNITQTY).toFixed(0)
       newRow.dcDET_VARQTY = parseFloat(item.dcDET_VARQTY).toFixed(txnDecimalQty)
       newRow.dcDET_SPRICE_OLD = parseFloat(item.dcDET_SPRICE).toFixed(txnDecimalAmt)
       newRow.dcDET_CPRICE_OLD = parseFloat(item.dcDET_CPRICE).toFixed(txnDecimalAmt)
       newRow.isDecimal = item.isDecimal
       newRow.fixGP = item.fixGP
       newGrid.push(newRow)
     })
 
     newGrid.sort((a, b) => a.id - b.id);

     TotalLineAmtCalcualtion(newGrid)
 
   }
 
   //* End Transaction DetaILS Save */
 
   //*Total Amount Calculation */
   const TxnTotalCal = async (refGrid = [], taxGrid = []) => {
 
     let DetTbl = []
 
     let GrossAmt = 0
     let NetAmt = 0
     let NetDiscount = 0
     let InvoiceDiscount = 0
 
     const newDataTable = refGrid.length > 0 ? refGrid : DataRow
 
     for (let i = 0; i < newDataTable.length; i++) {
 
       let txtcs = newDataTable[i].dcDET_CS
       let txtcode = newDataTable[i].strDET_PROCODE
       let txtunitqty = newDataTable[i].dcDET_UNITQTY
       let txtcaseqty = newDataTable[i].dcDET_CASEQTY
       let txtdiscper = newDataTable[i].dcDET_DISCPER
       let txtdicamt = newDataTable[i].dcDET_DISCAMT
       let txtamt = newDataTable[i].dcDET_AMOUNT
       let freeUnit = newDataTable[i].dcDET_FUNITQTY
       let freeCase = newDataTable[i].dcDET_FCASEQTY
       let txtsprice = newDataTable[i].dcDET_SPRICE
       let txtcprice = newDataTable[i].dcDET_CPRICE
       let txtaprice = newDataTable[i].dcDET_APRICE
       let avgCost = newDataTable[i].dcDET_ACOST
 
       let pp = newDataTable[i].dbPackPrice
       let cs = newDataTable[i].dcDET_CS
 
       let priceMode = 0
       if (txn.strTX_PRICEMODE == "C" || txn.strTX_PRICEMODE == "c") {
         priceMode = parseFloat(txtcprice.toString().replace(",", ""))
       } else if (txn.strTX_PRICEMODE == "S" || txn.strTX_PRICEMODE == "s") {
         priceMode = parseFloat(txtsprice.toString().replace(",", ""))
       } else if (txn.strTX_PRICEMODE == "A" || txn.strTX_PRICEMODE == "a") {
         priceMode = parseFloat(String(avgCost).toString().replace(",", ""))
       } else if (txn.strTX_PRICEMODE == "P" || txn.strTX_PRICEMODE == "p") {
         priceMode = parseFloat((pp / cs).toString().replace(",", ""))
       }
 
 
       if (txtcode.length != 0) {
 
         const cseQty = parseFloat(txtcaseqty == "" ? 0 : parseFloat(txtcaseqty))
         const totalCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? cseQty : cseQty * parseFloat(txtcs)
         const unitQty = parseFloat(txtunitqty == "" ? 0 : parseFloat(txtunitqty))
         const totalUnitQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? unitQty / parseFloat(txtcs) : unitQty
         const totalFreeUnit = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(freeUnit) / parseFloat(txtcs) : parseFloat(freeUnit)
         const freeCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(freeCase) / parseFloat(txtcs) : parseFloat(freeCase)
 
         let grossAmount = 0
 
         if (txn.intTX_BOM == 1) {
 
           grossAmount = parseFloat(priceMode) * (freeCaseQty)
 
         } else if (txn.intTX_PRODUCTION == 1 || txn.intTX_VERIFICATION == 1) {
           if (txn.intTX_VERIFICATION == 1) {
             grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty + parseFloat(totalFreeUnit)))
           } else {
             grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty - parseFloat(totalFreeUnit)))
           }
         } else {
           grossAmount = parseFloat(priceMode) * (totalCaseQty + totalUnitQty)
         }
 
         let NetAmount = 0
         if (txn.intTX_ALLOWMINUS == 1 && parseFloat(grossAmount) < 0) {
           NetAmount = grossAmount - ((parseFloat(txtdiscper) * grossAmount) / 100 - parseFloat(txtdicamt))
         } else {
           NetAmount = grossAmount - ((parseFloat(txtdiscper) * grossAmount) / 100 + parseFloat(txtdicamt))
         }
 
         GrossAmt = GrossAmt + parseFloat(NetAmount)
         NetAmt = NetAmt + parseFloat(NetAmount)
 
         // if it is a backoffice transaction  calculate line discount formula
         // if line discount and line discount amount is zero then use header discount percentage
 
         if (txn.intTX_SAVEINVOICE == 1 && parseFloat(txtdicamt) == 0 && parseFloat(txtdiscper) == 0) {
           InvoiceDiscount = parseFloat(InvoiceDiscount) + (parseFloat(txDiscount) * grossAmount) / 100
         } else {
           NetDiscount = NetDiscount + parseFloat(txtdicamt) + (parseFloat(txtdiscper) * grossAmount) / 100
         }
 
       }
     }
 
 
     SetGrossTotal(parseFloat(GrossAmt).toFixed(txnDecimalAmt)) //set gross total gross amount
 
 
     if (txn.intTX_SAVEINVOICE == 1) {
       SetTxDiscountAmt(parseFloat(NetDiscount) + parseFloat(InvoiceDiscount))
     } else {
       SetTxDiscountAmt((parseFloat(txDiscount) * NetAmt) / 100)
     }
 
     if (txn.intTX_PRODUCTION == 1) {
       if (NetAmt > 0) {
         SetTxDeduction(NetAmt)
         SetTxAddition(0)
         NetAmt = 0
         SetTxNetAmount(NetAmt)
         return
       } else {
         SetTxAddition(NetAmt * -1)
         SetTxDeduction(0)
         NetAmt = 0
         SetTxNetAmount(NetAmt)
         return
       }
 
       //NetAmt = NetAmt + parseFloat(txAddition) - parseFloat(txDeduction)
     } else {
       // NetAmt = NetAmt + parseFloat(txAddition) - parseFloat(txDeduction)
     }
 
 
     if (txn.intTX_SAVEINVOICE == 1) {
       NetAmt = NetAmt - parseFloat(InvoiceDiscount)
     } else {
       NetAmt = NetAmt - (parseFloat(txDiscount) * NetAmt) / 100
     }
 
     //wms requirement to calculate decution amount depend on the supplier contribution
     //deduct amount calculated using net amount and supplier contribution percentage
     const deductionCost = isWMS && parseFloat(supplierContribution) > 0 && txn.intTX_DEDUCTIONS == 1 ? parseFloat(GrossAmt) * parseFloat(supplierContribution) / 100 : txDeduction
 
     if (isWMS && parseFloat(supplierContribution) > 0 && txn.intTX_DEDUCTIONS == 1) {
       SetTxDeduction(parseFloat(deductionCost).toFixed(txnDecimalAmt))
     }
 
     NetAmt = NetAmt + parseFloat(txAddition) - parseFloat(deductionCost)
 
     let newClaculatedTaxTable = [...taxTable]
     if(calTax){
      newClaculatedTaxTable = await CalculateTaxAmountFromDetailTable(newDataTable, txnTaxTypes, taxGrid.length > 0 ? taxGrid : taxTable, txnDecimalAmt)
      SetTaxtTable(newClaculatedTaxTable)
     }


     const skipableTaxCodes = txnTaxTypes
                .filter(x => x.stop_Calculate == 1)  // Filter by stop_Calculate == 1
                .map(x => x.taxCode);  // Extract the taxCode from the filtered results


     const newInclusiveTax = newClaculatedTaxTable.filter(x => x.taxInclusive == 1).reduce((acc, item) => acc + item.taxAmount, 0)
     const newExclusiveTax = newClaculatedTaxTable.filter(x => x.taxInclusive == 0).reduce((acc, item) => acc + item.taxAmount, 0)

     //do not sum if the tax code is in skipableTax
     //check skipableTax is not empty 

     //skippedExclusiveTax values 
     const  skippedExclusiveTax = newClaculatedTaxTable.filter(x => x.taxInclusive == 0 && !skipableTaxCodes.includes(x.taxCode)).reduce((acc, item) => acc + item.taxAmount, 0)
 
     SetTxTaxInc(parseFloat(newInclusiveTax).toFixed(txnDecimalAmt))
     SetTxTaxExc(parseFloat(newExclusiveTax).toFixed(txnDecimalAmt))
 
     NetAmt = NetAmt + parseFloat(skippedExclusiveTax)
 
     SetTxNetAmount(parseFloat(NetAmt).toFixed(txnDecimalAmt))
     SetLineDisc(getLineDicTotal(newDataTable))
 
     return DetTbl
   }
 
 
   //* Transaction Tax Save */
   const TxnTax = async () => {
 
     return taxTable.map((item, index) => {
       return TaxBuilder(
         item.proCode,
         item.taxCode,
         item.grossAmt,
         item.taxRate,
         item.taxInclusive,
         item.taxAmount,
         item.detailRowID
       )
     })
 
   }
   //* End Transaction Tax Save */
 
   //* TaxBuilder */
   const TaxBuilder = (
     txtProCode,
     txtTax,
     txtGrossAmt,
     txtTaxRate,
     txtTaxInc,
     txtTaxAmount,
     txtLineno
   ) => {
 
     var TaxBuilder = {
       strTDET_PROCODE: txtProCode,
       strTDET_TAXCODE: txtTax,
       dcTDET_GROAMT: parseFloat(txtGrossAmt),
       dcTDET_TAXRATE: parseFloat(txtTaxRate),
       blTDET_TAXINC: txtTaxInc == 1 ? true : false,
       dcTDET_TAXAMT: parseFloat(txtTaxAmount),
       dcTDET_LINENO: txtLineno,
       lineNO: txtLineno,
     }
 
     return TaxBuilder
   }
   //* End TaxBuilder */
 
 
   /*The function below is used to handle remarks 
   1.it get detailTable as a parameter and return an array of remarks
   2.First filter the remarks by line number and empty remarks
   3.Then build the remarks object and return it*/
   const LineRemarks = async (DetailTable) => {
 
     let TblLine = []
     DetailTable.map((item, index1) => {
       var lineRemarkSet = TaxLineRemarks.filter((x) => x["LineNo"] == item["id"] && x["remark"] != "" && x["remark"] != null && x["remark"] != undefined)
       if (lineRemarkSet.length > 0) {
         lineRemarkSet.map((line, index2) => {
           TblLine.push(LineRemarksBuild(item["dcDET_LINENO"], line["remark"], index2 + 1))
         })
       }
     })
     return TblLine;
   }
 
 
   //* HedRemarks Save  */
   const HedRemarks = async() => {
     var TblLine = []
     RemHedDataRow.map((item, index) => {
       if (item.strRHED_REMARK != "") {
         TblLine.push(HedRemarksBuild(index + 1, item.strRHED_REMARK))
       }
     })
     return TblLine
   }
   //*End HedRemarks Save */
 
   //* Attachment Save  */
   const Attachment = async () => {
 
     let TblLine = []
     attachFileNames.map((item, index) => {
 
       TblLine.push({
         intAHED_LINENO: parseInt(item.lineNo),
         strAHED_FILEPATH: item.fileName,
       })
     })
     return TblLine
   }
   //*End Attachment Save */
 
   //*Line Remarks Build */
   const LineRemarksBuild = (LineNo, txtLineRem, remLine) => {
     return {
       intRDET_LINENO: parseInt(LineNo),
       strRDET_REMARK: isNull(txtLineRem) ? "" : txtLineRem,
       intRDET_REMLINE: parseInt(remLine)
     }
   }
   //*End Line Remarks Build*/
 
   //*Head Remarks Build */
   const HedRemarksBuild = (LineNo, txtLineRem) => {
     return {
       intRHED_LINENO: parseInt(LineNo),
       strRHED_REMARK: txtLineRem,
     }
   }
   //*End Head Remarks Build*/
 
 
   //* ClearItem */
   const ClearItem = async () => {
 
     try {
 
       setcustomActiveTab("1")
       let zeroset = parseFloat(0).toFixed(2)
 
       if (fileInputRef.current) {
         fileInputRef.current.value = '';
       }
 
 
       transactionProcess = 0
       SetTxnProcess(0)
       SetCancelDoc("")
       SetDocno("")
       SetRemoteData([])
       recCount = 0
       SetProcessStat("")
       SetDeliLocationSelect("")
       SetCustomerSelect("")
       SetRefTypeSelected("")
       SetCustomerSelectName("")
       SetBomSelect("")
       SetBomSelectName("")
       SetProSelect("")
       SetProSelectName("")
       SetBaseProduct("")
       SetAddNew(true)
       setGeneralFields({
          disableConsignment: false,
          autoOrderShow:false,
          autoOrderStartDate: "",
          autoOrderEndDate: "",
          autoOrderQty: 0,
          gpPopupShow: false,
          gpVarianceList: [],
          gpVerifying: false,
       })
       SetSupplierSelectName("")
       SetSupplierContribution(0)
       SetSkipSupplierApproval(false)
       SetSalesAssistantSelectName("")
       SetSalesAssistantSelect("")
       SetSupplierSelect("")
       setTxnTaxTypes([])
       SetGLBatchNo("")
       SetGrossTotal(zeroset)
       SetLineDisc(zeroset)
       SetTxNetAmount(zeroset)
       SetRefAmount(zeroset)
       SetTxnDate("")
       SetRefCode("")
       SetPriceModeSelect("")
       SetTxAddition(zeroset)
       SetTxDeduction(zeroset)
       SetTxDiscount(zeroset)
       SetTxTaxExc(zeroset)
       SetTxTaxInc(zeroset)
       setBomToValue(0)
       setBomToValue(0)
       SetRemarks1("")
       SetRemarks2("")
       SetReferenceRemark("")
       setCrEnable(false)
       SetRefDataRow([])
       SetTaxDetails([])
       SetTaxtTable([])
       setTaxProductCodes([])
       SetRemoteRequest([])
       SetTaxLineRemarks([{ LineNo: 1, remark: '', key: 0 }])
       SetTotalPayValue(zeroset)
       SetTxNetAmount(zeroset)
       setHandleClearStatus(prev => !prev)
       setReasonForDetails("")
       setRefStockFreeze(false)
       SetDataRow(transOBJ)
       SetRemHedDataRow([{ id: 1, strRHED_REMARK: "" }])
       setIsSaving(false)
       setMobileMan({
        user: "",
        remark: "",
       })
       SetPayDataRow([{
         id: 1,
         Paycode: "",
         PayCodeDisable: false,
         Paydesc: "",
         PayDetcode: "",
         PayDetcodeDesable: true,
         PayDetName: "",
         PayAmount: 0,
         PayAmountDisable: true,
         AccountCode: "",
         AccountCodeDisable: true,
         ExpDate: "",
         ExpDateDisable: true,
         PayDetFormat: "",
       }])
 
       SetTabList([
         {
           text: "Transaction",
           icon: "fas fa-home",
           tabID: "1",
           onClick: () => {
             toggleCustom("1")
           },
         },
         {
           text: "Details",
           icon: "far fa-user",
           tabID: "2",
           onClick: () => {
             toggleCustom("2")
           },
         },
         {
           text: "Remarks",
           icon: "far fa-user",
           tabID: "3",
           onClick: () => {
             toggleCustom("3")
           },
         },
         {
           text: "Attachments",
           icon: "far fa-user",
           tabID: "4",
           onClick: () => {
             toggleCustom("4")
           },
         },
 
 
       ])
 

       //* Disable Enable  */
       setSaveEnable(true)
       SetDocNoDisable(false)
       Setdisabled(false)
       SetdisabledPriceMode(false)
       SetdisabledRemarks(false)
       SetdisabledCustomer(false)
       SetdisabledDate(false)
       SetDateDisableFields(prevState => ({
          ...prevState,
          txtDate: false,
          validDate: false,
          validFromDate: false,
          validToDate: false
        })
        )
       SetdisabledSupplier(false)
       SetdisabledRefType(false)
       SetdisabledSA(false)
       SetdisabledFL(false)
       SetdisabledTL(false)
       SetdisabledDL(false)
       SetDisableDet(false)
       setSubDocs([])
       setCalTax(true)
       setSubDocApprove(true)
       setRequiredReason(false)
       setSpecialPermissionCode(0)
       let dates = new Date()
       var currentDate = dates.toISOString().substring(0, 10)
       SetTxnDate(currentDate)
       if (txn.intTX_NOTCREATABLE == 1) {
         setSaveEnable(false)
         Setdisabled(true)
         SetdisabledPriceMode(true)
         SetdisabledRemarks(true)
         SetdisabledCustomer(true)
         SetdisabledDate(true)
         SetDateDisableFields(prevState => ({
            ...prevState,
            txtDate: true,
            validDate: true,
            validFromDate: true,
            validToDate: true
          })
         )
         SetdisabledSupplier(true)
         SetdisabledRefType(true)
         SetdisabledSA(true)
         SetdisabledFL(true)
         SetdisabledTL(true)
         SetdisabledDL(true)
         SetDisableDet(true)
 
       }
 
       if (parseInt(txn.intTX_VALIDTILLDATE) > 0) {
 
         let currentDate = new Date()
         let validTillDate = new Date()
         //add given dat4es to current date
         validTillDate.setDate(currentDate.getDate() + parseInt(txn.intTX_VALIDTILLDATE))
         SetValidFromDate(currentDate.toISOString().slice(0, 10))
         SetValidToDate(validTillDate.toISOString().slice(0, 10))
       } else {
         SetValidFromDate("")
         SetValidToDate("")
       }
 
       var obj = JSON.parse(localStorage.getItem("authUser")) //get user details
       var user = obj[2] //get user type
       var LoggedLocation = obj[3] //get user location
 
       var fromLoc = await getTxnLocations(type, user, 1, LoggedLocation)
       SetFromLocation(fromLoc)
       var findLoggedLocation = fromLoc.find(x => x.value == LoggedLocation)
 
       //check if findLoggedLocation is undefined
 
       if (findLoggedLocation != undefined) {
         SetFromLocationSelect(LoggedLocation)
       } else {
         SetFromLocationSelect("")
       }
 
 
       if (txn.intTX_FROMLOCSETUP == 1) {
         SetdisabledFL(true)
       }
       if (txn.intTX_TOLOCSETUP == 1) {
         SetdisabledTL(true)
       }
       SetToLocationSelect("")
 
 
       if (parseInt(txn.intTX_VALIDTILLDATE) == 0) { //check if valid to date is 0
         SetValidToDate("")
         SetValidFromDate("")
       }
 
       var barcodeElement = document.getElementById("ScanBarCode");
       if (barcodeElement) {
         barcodeElement.value = "";
       }
 
       //reset remarks
       const result = await GetHeaderReasonTypes(type)
 
       if (result.success) {
         setSummaryRemarksList(result.data)
       } else {
         setSummaryRemarksList([])
       }
 
 
     } catch (error) {
       console.log(error)
     }
 
   }
   //*End ClearItem */
 
 
 
   function WaitFunction(ms) {
     return new Promise(resolve => setTimeout(resolve, ms));
   }
 
   //**Start Save Payment */
   const txnPayment = () => {
 
     var PaymentDet = []
 
     PayDataRow.map((item, index) => {
       if (item.PayAmount > 0 && item.Paycode != '') {
         PaymentDet.push(
           PaymentBuilder(
             item.Paycode,
             item.PayDetcode,
             item.AccountCode,
             1,
             item.ExpDate,
             item.PayAmount,
             txNetAmount.toString()
           )
         )
       }
     })
     return PaymentDet;
   }
 
   const PaymentBuilder = (
     strPHCode,
     strPDCode,
     strRefNo,
     dcRate,
     dtPayTypeDate,
     dcPaidAmount,
     dcAmount
   ) => {
     let date = new Date().toISOString();
 
     return {
       dcPaidAmount: parseFloat(dcPaidAmount.replace(',', '')),
       dtDateTime: date,
       dcAmount: parseFloat(dcAmount.replace(',', '')),
       intCancelled: 0,
       strPDCode: strPDCode,
       strPHCode: strPHCode,
       strRefNo: strRefNo,
       dtPayTypeDate: dtPayTypeDate.length > 0 ? dtPayTypeDate : "1900-01-01",
       dcRate: parseFloat(dcRate)
     }
   }
   //**End Save Payment */
 
 
   //* Transaction Save */
   const SaveTransaction = async (ISPROCESSED = 0) => { // transaction save FUNCTION all the parameters should check and validate beforesaving
 
    setIsSaving(true)

     var obj = JSON.parse(localStorage.getItem("authUser"))
     let LogUserType = obj[2]
     let LocationCode = obj[3]
     let CompanyCode = obj[5]
     //let menu = localStorage.getItem("MenuCode")
 
     //url with http
     const url = window.location.href
     const urlArr = url.split("/Transaction")
     const displayUrl = urlArr[0] + "/Transaction"
 
 
     // The variable is named newDate, not txndate
     let currentDate = new Date(txndate);
     let cmonth = currentDate.getMonth() + 1
     let cyear = currentDate.getFullYear()
 
     if (txn.intTX_CHKMONTHEND == 1) { //monthend validation check
       if (currentRunningMonth != cmonth || currentRunningYear != cyear) {
         displayAlertMessage("danger", `The date you selected does not tally with the current system month and year! Current month is ${currentRunningMonth} and year is ${currentRunningYear} `)
          setIsSaving(false)
         return
       }
     }
 
     if (txn.intTX_CHKPOSEOD == 1) {
       let date = new Date()
       let SysDate = new Date(txn.dtSETUP_ENDDATE)
       if (SysDate >= date) {
         setshowCancel(false)
         setBtnYes("Ok")
         displayAlertMessage("danger", `Please complete the EOD before proceed !`)
          setIsSaving(false)
         return
       }
     }
 
     if (txn.intTX_SAVEINVOICE == 1 && parseFloat(txNetAmount).toFixed(txnDecimalAmt) != TotalPayCalculation()) {
       displayAlertMessage("danger", `Paid amount should equal to net amount !`)
        setIsSaving(false)
       return
     }
 
     if (txn.intTX_CHKPOSEOD == 1) {
       let date = new Date()
       let SysDate = new Date(txn.dtSETUP_ENDDATE)
       if (SysDate >= date) {
         displayAlertMessage("danger", `Please complete the EOD before proceed !`)
         setIsSaving(false)
         return
       }
     }
 
     if (txn.intTX_REFOPTIONAL == 0 && RefCode == "" && txn.strTX_REFTYPES != "") {
       displayAlertMessage("danger", `Please Enter Ref Number`)
       setIsSaving(false)
       return
     }
 
     if (txn.strTX_SOURCEINV != "N" && txn.strTX_SOURCEINV != "" && fromLocationSelect == "") {
       displayAlertMessage("danger", `Please Select from Location before save !`)
       setIsSaving(false)
       return
     }
 
     if (txn.intTX_SUPPLIER == 1 && supplierSelect == "") {
       displayAlertMessage("danger", `Please Select Supplier before save !`)
       setIsSaving(false)
       return
     }
 
     if (txn.strTX_DESTINV != "N" && txn.strTX_DESTINV != "" && toLocationSelect == "") {
       let loc = toLocationSelect == "" ? "to " : "delivery/destination "
       displayAlertMessage("danger", `Please Select ${loc}location before save !`)
       setIsSaving(false)
       return
     }
 
 
     if (txn.intTX_REF1_VALIDATE == 1 && remarks1 == "") {
       displayAlertMessage("danger", `Please Enter ${txn.strTX_REF1} !`)
       setIsSaving(false)
       return
     }
 
     if (txn.intTX_REF2_VALIDATE == 1 && remarks2 == "") {
       displayAlertMessage("danger", `Please Enter ${txn.strTX_REF2} !`)
       setIsSaving(false)
       return
     }
 
 
     if(txn.intTX_CHECK_SUP_CREDIT == 1 && ISPROCESSED == 1){

      try{
        SetLoadingAlert(true);
        SetLoadingAlerttitle("Checking Supplier Credit Limit...")
        const supResponse = await getSupplierCredit(LocationCode)

        if(supResponse.isSuccess){
  
          const totalOutstanding = parseFloat(supResponse.outstandingAmount) + parseFloat(txNetAmount)
  
          if(parseFloat(supResponse.creditAmount) < totalOutstanding){
            displayAlertMessage("danger", `Your credit limit is ${supResponse.creditAmount} and outstanding amount is ${supResponse.outstandingAmount}.
               Value of the current transaction is ${txNetAmount}. You can not proceed with this transaction due to insufficient credit balance.`);
            return
          }
  
        }else{
          displayAlertMessage("danger", supResponse.msg)
          return
        }
      }catch(error){
        displayAlertMessage("danger", error)
        return
      }finally{
        setIsSaving(false)
        SetLoadingAlert(false);
      }

      
     }


 
     let detailTbl = []
     const detailTablewithID = await HandleDetailTable(DataRow, saleAssistantSelect, type, txn, refStockFreeze, ISPROCESSED, proSelect,RefCode)  // this function is used to handle the detail table and return the detail table
 
     if (detailTablewithID.success == false) {
       displayAlertMessage("danger", detailTablewithID.message)
       setIsSaving(false)
       return false
     }
 
     recCount = detailTablewithID.recCount
 
     let TaxDetails = await TxnTax()
     let LineRemark = await LineRemarks(detailTablewithID.data)
 
     detailTablewithID.data.map((item, index) => {
       delete item.id
       detailTbl.push(item)
     })

     
     // if the traisaction is first in first out one then we have to group the items by code and stock code and sum the qty and compare with the reference array
     if(txn.intTX_FIFO == 1){
      
      //in the reference array we have to group items by code and stock code and sum the qty
      const referenceArray_itemCount =  groupByCodeAndStockBalQty(RefDataRow);
      const detailArray_itemCount =  groupByCodeAndStock(detailTbl);

      const comparisonResult = compareTotalQuantity(referenceArray_itemCount, detailArray_itemCount);

      if (comparisonResult.errors.length > 0) {
        displayAlertMessage("danger", comparisonResult.errors.join("\n"))
        setIsSaving(false)
        return;
      }

     }

 
     var isDeduct = false
 
     if (txn.intTX_PRODUCTION == 1) {
 
       for (let i = 0; i < detailTbl.length; i++) {
 
         if (i == 0) {
           if (parseFloat(detailTbl[i].dcDET_UNITQTY) == parseFloat(detailTbl[i].dcDET_FUNITQTY)) {
             displayAlertMessage("danger", `Add or Deduct quantitiy can not be same!`)
             setIsSaving(false)
             return false
           }
 
           if (parseFloat(detailTbl[i].dcDET_UNITQTY) > parseFloat(detailTbl[i].dcDET_FUNITQTY)) {
             if (parseFloat(detailTbl[i].dcDET_FUNITQTY) != 0) {
               displayAlertMessage("danger", `Deduct quantity should be 0  in line no ${i + 1}`)
               setIsSaving(false)
               return false
             }
           } else if (parseFloat(detailTbl[i].dcDET_UNITQTY) < parseFloat(detailTbl[i].dcDET_FUNITQTY)) {
             if (parseFloat(detailTbl[i].dcDET_UNITQTY) != 0) {
               displayAlertMessage("danger", `Add quantity should be 0 in line no ${i + 1}`)
               setIsSaving(false)
               return false
             }
             isDeduct = true
           }
 
         } else {
           if (isDeduct) {
             if (parseFloat(detailTbl[i].dcDET_FUNITQTY) != 0) {
               displayAlertMessage("danger", `Deduct quantity should be 0 in line no ${i + 1}`)
               setIsSaving(false)
               return false
             }
           } else {
             if (parseFloat(detailTbl[i].dcDET_UNITQTY) != 0) {
               displayAlertMessage("danger", `Add quantity should be 0 in line no ${i + 1}`)
               setIsSaving(false)
               return false
             }
           }
         }
 
       }
     }
     // type == 'PRE'
     if (txn.intTX_PRODUCTION == 1) {
       if (detailTbl.length < 2) {
         displayAlertMessage("danger", `Please Enter atleast two items!`)
         setIsSaving(false)
         return false
       }
     } else {
       if (detailTbl.length < 1) {
         displayAlertMessage("danger", `Please Enter atleast one item!`)
         setIsSaving(false)
         return false
       }
     }
 
     if (subDocApprove == false) {
       displayAlertMessage("danger", `Invalid Sub Document!`)
       setIsSaving(false)
       return false
     }
 
 
     if (txn.intTX_VALIDFROMDATE == 1) {
       if (validFromDate == "") {
         displayAlertMessage("danger", `Please Enter ${txn.strTX_VALIDFROMDATE_CAPTION == '' ? "Valid From" : txn.strTX_VALIDFROMDATE_CAPTION} !`)
         setIsSaving(false)
         return false
       }
     }
 
     if (txn.intTX_VALIDTODATE == 1) {
       if (validToDate == "") {
         displayAlertMessage("danger", `Please Enter ${txn.strTX_VALIDTODATE_CAPTION == '' ? "Valid To" : txn.strTX_VALIDTODATE_CAPTION} !`)
         setIsSaving(false)
         return false
       }
     }
 
     if (txn.intTX_VALIDFROMDATE == 1 && txn.intTX_VALIDTODATE == 1) {
       if (validFromDate > validToDate) {
         displayAlertMessage("danger", `${txn.strTX_VALIDFROMDATE_CAPTION == '' ? "Valid From" : txn.strTX_VALIDFROMDATE_CAPTION} should be less than ${txn.strTX_VALIDTODATE_CAPTION == '' ? "Valid To" : txn.strTX_VALIDTODATE_CAPTION} !`)
         setIsSaving(false)
         return false
       }
     }
 
 
     if (selectedAttachFiles.length > 0) {
       displayAlertMessage("danger", `Please upload the selected files before save !`)
       setcustomActiveTab("4")
       setIsSaving(false)
       return false
     }
 
     if (txn.intTX_CHKREFAMT == 1) {
       if (parseFloat(txNetAmount) != parseFloat(txRefAmount)) {
         displayAlertMessage("danger", `Net amount should be equal to reference amount !`)
         setIsSaving(false)
         return false
       }
     }
 
     if (fromLocationSelect == "" && txn.strTX_SOURCEINV != "N" && txn.strTX_SOURCEINV != "") {
       displayAlertMessage("danger", `Please select from location !`)
       setIsSaving(false)
       return false
     }
 
     if (toLocationSelect == "" && txn.strTX_DESTINV != 'N' && txn.strTX_DESTINV != '') {
       displayAlertMessage("danger", `Please select To location !`)
       setIsSaving(false)
       return false
     }
 
     if (txn.strTX_DESTINV != "N" && txn.strTX_DESTINV != "" && txn.strTX_SOURCEINV != "N" && txn.strTX_SOURCEINV != "") {
       if (fromLocationSelect == toLocationSelect) {
         displayAlertMessage("danger", `From location and to location should not be same !`)
         setIsSaving(false)
         return false
       }
     }
 
     const attachmentList = await Attachment()

     if(txn.intTX_IS_ATTACHMENT_REQUIRED == 1 && attachmentList.length == 0 && ISPROCESSED == 1){
        displayAlertMessage("danger", `Please upload at least one attachment before save !`)
        setcustomActiveTab("4")
        setIsSaving(false)
        return false
     }




     if (remarks2) {
      const isRef2Available = summaryRemarksList.find((item) => item.value === remarks2);
      
      if (isRef2Available?.reqTxnRef1) {
        if (!remarks1 && txn.strTX_REF1 !="") {
          displayAlertMessage("danger", `Please Enter ${txn.strTX_REF1} !`);
          setIsSaving(false);
          return false;
        }
      }
    }

    const headerRemarkList = await HedRemarks()
 
    if (txn.intTX_REFHEADER_VALIDATE == 1 && headerRemarkList.length == 0) {
      displayAlertMessage("danger", `Please Enter Remarks!`)
      setIsSaving(false)
      return false
    }

    
      //skip approval rules based on the transaction type and the selected supplier approval status
      const skipApprovalRules = txn.intTX_SKIP_SUPPLIER_APPROVALS == 1 && skipSupplierApproval ? true : false

     //Check Custom Rules for Save
     if ((txn.intTX_TEMPSAVE == 0 || ISPROCESSED == 1) && !skipApprovalRules) {
 
       var RuleList = await GetRules(menuCode)

       if (RuleList.length > 0) {
        const ruleValidationResult = await RuleValidate(RuleList, detailTbl) // this function is used to validate the rules
      
        if(!ruleValidationResult){
          return false;
        }
        
      }
 
       if (remarks2 != "") {
 
         if (RefCode != "" && referenceRemark != "" && referenceRemark != remarks2) {
           const response = await RemarkValidation(remarks2, LogUserType)
 
           if (response.isSuccess && response.data == false) {
 
             let reasonDescription = ''
             const isRef2Available = summaryRemarksList.find((item) => item.value == remarks2)
             if (isRef2Available) {
               reasonDescription = isRef2Available.label
             }
 
             let objRuleLine = []
             objRuleLine = remoteRequest;
             objRuleLine.push({
               strRA_TXN_TYPE: type,
               strRA_TXN_NO: "NAN",
               strRA_TXN_LOCATION: LocationCode,
               dtRA_TXN_DATE: new Date(),
               dcRA_TXN_VALUE: parseFloat(txNetAmount),
               strRA_TXN_PERMISSION: `RC${remarks2}`,
               strRA_REQUEST: "Reason Type Permission! Reason: " + reasonDescription,
               intRA_PRIORITY: 1,
               shrtRA_APPROVED: 0,
               strRA_APPRIVED_BY: "",
               strRA_REMARKS: "",
             })
             SetRemoteRequest(objRuleLine)
           }
 
           await WaitFunction(200)
         } else if (RefCode != "" && referenceRemark != "" && referenceRemark == remarks2) {
 
           //if the reference types are equal no need to chek remark permission
 
         } else {
           const response = await RemarkValidation(remarks2, LogUserType)
 
           if (response.isSuccess && response.data == false) {
             let objRuleLine = []
 
             let reasonDescription = ''
             const isRef2Available = summaryRemarksList.find((item) => item.value == remarks2)
             if (isRef2Available) {
               reasonDescription = isRef2Available.label
             }
 
 
             objRuleLine = remoteRequest;
             objRuleLine.push({
               strRA_TXN_TYPE: type,
               strRA_TXN_NO: "NAN",
               strRA_TXN_LOCATION: LocationCode,
               dtRA_TXN_DATE: new Date(),
               dcRA_TXN_VALUE: parseFloat(txNetAmount),
               strRA_TXN_PERMISSION: `RC${remarks2}`,
               strRA_REQUEST: "Reason Type Permission! Reason: " + reasonDescription,
               intRA_PRIORITY: 1,
               shrtRA_APPROVED: 0,
               strRA_APPRIVED_BY: "",
               strRA_REMARKS: "",
             })
             SetRemoteRequest(objRuleLine)
           }
           await WaitFunction(200)
         }
       }
 
      }
 
     let AllApproved = false;
 
     const filteredRemoteData = remoteData.filter((item) => item.shrtRA_APPROVED != 3)
 
     if (remoteData.length > 0 && ISPROCESSED === 1 && docNo.length > 0) {
       let hasZero = false; // Flag to check for '0'
       let hasTwo = false;  // Flag to check for '2'
       let hasOne = false;  // Flag to check for '1'
 
       for (let j = 0; j < filteredRemoteData.length; j++) {
         if (filteredRemoteData[j].shrtRA_APPROVED === 0) {
           hasZero = true;
         }
         if (filteredRemoteData[j].shrtRA_APPROVED === 2) {
           hasTwo = true;
         }
         if (filteredRemoteData[j].shrtRA_APPROVED === 1) {
           hasOne = true;
         }
       }
 
       if (hasOne) {
         AllApproved = true;
       }
       if (hasZero) {
         AllApproved = false;
       }
       if (hasTwo) {
         AllApproved = false;
       }
 
     }
 

     let subDocArray = []
     detailTbl.map((pro, index) => {
       let ItemsInSubDoc = subDocs.filter((item) => item.prO_CODE == pro.strDET_PROCODE)
       ItemsInSubDoc.map((item, index) => {
         subDocArray.push({
           SDC_LINENO: parseFloat(pro.dcDET_LINENO),
           PRO_CODE: item.prO_CODE,
           LOC_CODE: item.loC_CODE,
           QTY: item.qty,
         })
       })
     })
 
 
     var datey = new Date()
     var hours = datey.getHours() < 10 ? "0" + datey.getHours() : datey.getHours()
     var minitues = datey.getMinutes() < 10 ? "0" + datey.getMinutes() : datey.getMinutes()
     var seconds = datey.getSeconds() < 10 ? "0" + datey.getSeconds() : datey.getSeconds()
     const transTime = txndate + "T" + hours + ":" + minitues + ":" + seconds
 
 
     const modifiredRemoteRequest = remoteRequest.map((item) => {
       return {
         ...item,
         baseURL: displayUrl,
       }
     })
 
 
     var myHeaders = new Headers()
     myHeaders.append("Content-Type", "application/json")
     myHeaders.append("Authorization", `Bearer ${authToken}`)
 
 
     var raw = JSON.stringify({
       strHED_TYPE: type,
       strHED_REFTYPE: refTypeSelected,
       strHED_RUNNO: docNo.length > 0 ? docNo : "NAN",
       dtHED_TXNDATE: txndate,
       dtHED_PROCDATE: txndate,
       dtHED_TXNTIME: transTime,
       dtHED_VALIDFROMDATE: validFromDate == "" ? "1990-01-01" : validFromDate.slice(0, 10),
       dtHED_VALIDTODATE: validToDate == "" ? "1990-01-01" : validToDate.slice(0, 10),
       strHED_SETUPLOC: setupLocation,//setupLocation
       strHED_LOCFROM: fromLocationSelect,
       strHED_LOCTO: toLocationSelect,
       strHED_LOCDEL: deliLocationSelect,
       strHED_COMCODE: CompanyCode,
       strHED_PRICEMODE: priceModeSelect, //txn.strTX_PRICEMODE,
       strHED_CUSCODE: txn.intTX_BOM == 1 ? bomSelect : customerSelect,
       strHED_LOC: LocationCode,
       strHED_SUPCODE: txn.intTX_BOM == 1 ? proSelect : supplierSelect,
       strHED_SACODE:saleAssistantSelect,
       strHED_REFNO: RefCode,
       strHED_REF1: remarks1,
       strHED_REF2: remarks2,
       decHED_SELLAMT: parseFloat(txNetAmount),
       decHED_GROSSAMT: parseFloat(GrossTotal),
       decHED_DISCPER: parseFloat(txDiscount),
       decHED_ITAXAMT: parseFloat(txTaxInc),
       decHED_ETAXAMT: parseFloat(txTaxExc),
       decHED_ADDAMT: parseFloat(txAddition),
       decHED_DEDAMT: parseFloat(txDeduction),
       decHED_NETAMT: parseFloat(txNetAmount),
       decHED_RECCOUNT: recCount,
       decHED_REFCOUNT: 0,
       intHED_PROCESSED: modifiredRemoteRequest.length > 0 && ISPROCESSED == 1 && docNo.length > 0 && AllApproved == true ? 1 : modifiredRemoteRequest.length > 0 ? 0 : txn.intTX_TEMPSAVE == 1 ? ISPROCESSED : 1,
       intHED_LOCKED: 0,
       intHED_CANCELLED: 0,
       dtHED_CANDATE: "1900-01-01",
       strHED_CANUSER: "",
       intHED_PRINTCOUNT: 0,
       intHED_REFDOCVAL: 0,
       intHED_FULLYUSED: 0,
       intHED_EXPORT: 0,
       strHED_EXPBATCH: "",
       strCR_BY: LogUserType,
       strHED_EXTREFDOC: "",
       strMenuCode: menuCode,
       strLoggedCompany: CompanyCode,
       strLoggedLocation: LocationCode,
       strReason: Reason,
       objTXN_DETSAVE: detailTbl,
       objTXN_DETTAXSAVE: TaxDetails,
       objTXN_DETREMDETSAVE: LineRemark, //TblLineRem,
       objTXN_DETREMHEDSAVE: headerRemarkList, //HedRemark
       objTXN_DETATTHEDSAVE: attachmentList,//Attachment(), //Attach
       objPayment: txnPayment(),//Payments
       objPaymentRes: [], //Payments
       objTXN_DETSUBDOCS: subDocArray, //SubDocs
       objApprovalRequest: modifiredRemoteRequest,//ApprovalRequest
       proBins: [],
       shelfUser:mobileMan.user,
       shelfRemark:mobileMan.remark
     })
 
 
     SetLoadingAlert(true)
     SetLoadingAlerttitle("Saving...")
 
 
     var requestOptions = {
       method: "POST",
       headers: myHeaders,
       body: raw,
       redirect: "follow",
     }
 
     try {
 
       const response = await fetch(`${ApiURL}txn`, requestOptions);
       SetLoadingAlert(false);
 
       const responseData = await response.json();
 
       if (responseData.success) {
 
         const filteredData = remoteData.filter(item => item.shrtRA_APPROVED !== 3)
 
         const AllApproved = filteredData.length > 0 ? filteredData.every(item => item.shrtRA_APPROVED === 1) : false
 
         if (remoteData.length > 0 && AllApproved) {
           ClearItem()
         } else if (remoteRequest.length > 0) {
           SendPermissionRequest(responseData.data)
           toggleApp()
         } else {
           ClearItem()
         }
 
         localStorage.removeItem(type)
         SetDocno(remoteRequest.length > 0 && !AllApproved ? responseData.data : "")
         displayAlertMessage("success", responseData.message)
         setcustomActiveTab("1")
         setPrintDoc(responseData.data)
         setTimeout(() => {
           setAlertDescription("Do you wish to print this document ?")
           setAlertConfirmOption(6)
           setsweetAlertShow(true)
         }, 10)
 
       } else {
         displayAlertMessage("danger", responseData.message)	//display alert message
       }
 
     } catch (error) {
       // Handle errors here
       console.error('Error:', error);
     }finally{
      SetLoadingAlert(false);
      setIsSaving(false)
     }
 
   }
 


   const groupByCodeAndStock = (arr) => {
    
    return arr.reduce((acc, curr) => {
      const key = `${curr.strDET_PROCODE}-${curr.strDET_STOCKCODE}`; // Unique key combining product code and stock code
      
      // Calculate the total quantity using the given formula
      const quantity = parseFloat(curr.dcDET_CASEQTY) * parseFloat(curr.dcDET_CS) + 
                       parseFloat(curr.dcDET_UNITQTY)
  
      // If the key doesn't exist, initialize it
      if (!acc[key]) {
        acc[key] = {
          totalQuantity: 0
        };
      }
          
      // Update the total quantity for this group
      acc[key].totalQuantity += quantity;
  
      return acc;
    }, {});

   }


   const groupByCodeAndStockBalQty = (arr) => {
    
    return arr.reduce((acc, curr) => {
      const key = `${curr.strDET_PROCODE}-${curr.strDET_STOCKCODE}`; // Unique key combining product code and stock code
      
      // Calculate the total quantity using the given formula
      const quantity = parseFloat(curr.dcDET_BALQTY)

      // If the key doesn't exist, initialize it
      if (!acc[key]) {
        acc[key] = {
          totalQuantity: 0
        };
      }
          
      // Update the total quantity for this group
      acc[key].totalQuantity += quantity;
  
      return acc;
    }, {});

   }



   const compareTotalQuantity = (referenceArray, detailArray) => {
    const result = { errors: [] };
  
    // Check for errors in detailArray compared to referenceArray
    for (const key in detailArray) {
      // Check if totalQuantity in detailArray is greater than in referenceArray
      if (key in referenceArray) {
        const referenceTotalQuantity = referenceArray[key].totalQuantity;
        const detailTotalQuantity = detailArray[key].totalQuantity;
  
        if (detailTotalQuantity > referenceTotalQuantity) {
          const keyPrefix = key.split('-')[0]; // Get the first part of the key
          const stockCode = key.split('-')[1]; // Get the second part of the key
          result.errors.push(`Total quantity for the item ${keyPrefix} Stockcode ${stockCode} in grid is greater than in reference document total.`);
          return result; // Return the first error
        }
      }
  
      // Find items that are in detailArray but not in referenceArray
      if (!(key in referenceArray)) {
        const keyPrefix = key.split('-')[0]; // Get the first part of the key
        const stockCode = key.split('-')[1]; // Get the second part of the key
        result.errors.push(`Stockcode ${stockCode} found in grid but not in reference document.`);
        return result; // Return immediately when an item is found in detailArray but not in referenceArray
      }
    }
  
    return result; // No errors found
  };

 
   //*Start Transaction Rule Check */
   const RuleValidate = async (RuleList, DetailTable) => {
 
     for (let i = 0; i < RuleList.length; i++) {
 
       let permission = await GetPermissionList(`${menuCode}-${RuleList[i].intID}`);
       // debugger
       if (RuleList[i].strMode == "D") {
         DetailTable.map(async (row) => {
          const detValidResponse = await DetRuleBuilder(RuleList[i], row, permission, DetailTable)
            //breake the loop and show error message
            if(!detValidResponse){
              displayAlertMessage("danger", `Rule ${RuleList[i].strCheckingDesc} | Rule validation failed`)
              setIsSaving(false)
              return false
            }
         })
       }

       if (RuleList[i].strMode == "H") {
         const validResponse =  await HEDRuleBuilder(RuleList[i], permission, DetailTable)
         //breake the loop and show error message
          if(!validResponse){
            displayAlertMessage("danger", `Rule ${RuleList[i].strCheckingDesc} | Rule validation failed`)
            setIsSaving(false)
            return false
          }
       }
     }

      return true

   }



   
   const HEDRuleBuilder = async (objRule, PermissionList, DetailTable) => {
     let rule = objRule.strRule;
     if (rule == "P") {
       let objRuleLine = []
       objRuleLine = remoteRequest;
       objRuleLine.push({
         strRA_TXN_TYPE: type,
         strRA_TXN_NO: "NAN",
         strRA_TXN_LOCATION: LocationCode,
         dtRA_TXN_DATE: new Date(),
         dcRA_TXN_VALUE: parseFloat(txNetAmount),
         strRA_TXN_PERMISSION: `${menuCode}-${objRule.intID}`,
         strRA_REQUEST: RuleDescBuilder(objRule.strCheckingDesc, ""),
         intRA_PRIORITY: objRule.intPriority,
         shrtRA_APPROVED: 0,
         strRA_APPRIVED_BY: "",
         strRA_REMARKS: "",
       })
       SetRemoteRequest(objRuleLine)
       return true
     }
     if (rule.includes("HED_TYPE")) {
       rule = rule.replaceAll("HED_TYPE", type);
     }
     if (rule.includes("HED_REFTYPE")) {
       rule = rule.replaceAll("HED_REFTYPE", refTypeSelected);
     }
     if (rule.includes("HED_RUNNO")) {
       rule = rule.replaceAll("HED_RUNNO", docNo.length > 0 ? docNo : "NAN");
     }
     if (rule.includes("HED_LOCFROM")) {
       rule = rule.replaceAll("HED_LOCFROM", fromLocationSelect);
     }
     if (rule.includes("HED_LOCTO")) {
       rule = rule.replaceAll("HED_LOCTO", toLocationSelect);
     }
     if (rule.includes("HED_LOCDEL")) {
       rule = rule.replaceAll("HED_LOCDEL", deliLocationSelect);
     }
     if (rule.includes("HED_PRICEMODE")) {
       rule = rule.replaceAll("HED_PRICEMODE", priceModeSelect);
     }
     if (rule.includes("HED_CUSCODE")) {
       rule = rule.replaceAll("HED_CUSCODE", customerSelect);
     }
     if (rule.includes("HED_SUPCODE")) {
       rule = rule.replaceAll("HED_SUPCODE", supplierSelect);
     }
     if (rule.includes("HED_REFNO")) {
       rule = rule.replaceAll("HED_REFNO", RefCode);
     }
     if (rule.includes("HED_REF1")) {
       rule = rule.replaceAll("HED_REF1", remarks1);
     }
     if (rule.includes("HED_REF2")) {
       rule = rule.replaceAll("HED_REF2", remarks2);
     }
     if (rule.includes("HED_SELLAMT")) {
       rule = rule.replaceAll("HED_SELLAMT", parseFloat(txNetAmount));
     }
     if (rule.includes("HED_GROSSAMT")) {
       rule = rule.replaceAll("HED_GROSSAMT", parseFloat(GrossTotal));
     }
     if (rule.includes("HED_DISCPER")) {
       rule = rule.replaceAll("HED_DISCPER", parseFloat(txDiscount));
     }
     if (rule.includes("HED_ITAXAMT")) {
       rule = rule.replaceAll("HED_ITAXAMT", parseFloat(txTaxInc));
     }
     if (rule.includes("HED_ETAXAMT")) {
       rule = rule.replaceAll("HED_ETAXAMT", parseFloat(txTaxExc));
     }
     if (rule.includes("HED_ADDAMT")) {
       rule = rule.replaceAll("HED_ADDAMT", parseFloat(txAddition));
     }
     if (rule.includes("HED_DEDAMT")) {
       rule = rule.replaceAll("HED_DEDAMT", parseFloat(txDeduction));
     }
     if (rule.includes("HED_NETAMT")) {
       rule = rule.replaceAll("HED_NETAMT", parseFloat(txNetAmount));
     }
     if (rule.includes("HED_RECCOUNT")) {
       rule = rule.replaceAll("HED_RECCOUNT", recCount);
     }
     if (rule.includes("HED_REFCOUNT")) {
       rule = rule.replaceAll("HED_REFCOUNT", 0);
     }
     if (rule.includes("HED_PROCESSED")) {
       rule = rule.replaceAll("HED_PROCESSED", txn.intTX_TEMPSAVE == 1 ? transactionProcess : 1);
     }
     if (rule.includes("AND")) {
       rule = rule.replaceAll("AND", "&&");
     }
     if (rule.includes("OR")) {
       rule = rule.replaceAll("OR", "||");
     }
     if (rule.includes("\r\n")) {
       rule = rule.replaceAll("\r\n", "");
     }
 

    try{
      if (eval(rule)) {

        if (PermissionList && PermissionList.strMenuAccessRight == false) {
          let objRuleLine = []
          objRuleLine = remoteRequest;
          objRuleLine.push({
            strRA_TXN_TYPE: type,
            strRA_TXN_NO: "NAN",
            strRA_TXN_LOCATION: LocationCode,
            dtRA_TXN_DATE: new Date(),
            dcRA_TXN_VALUE: parseFloat(txNetAmount),
            strRA_TXN_PERMISSION: `${menuCode}-${objRule.intID}`,
            strRA_REQUEST: RuleDescBuilder(objRule.strCheckingDesc, ""),
            intRA_PRIORITY: objRule.intPriority,
            shrtRA_APPROVED: 0,
            strRA_APPRIVED_BY: "",
            strRA_REMARKS: "",
          })
          SetRemoteRequest(objRuleLine)
        }

      }

      return true;
    }catch(error){
      console.error("Error in HEDRuleBuilder:", error);
      return false; 
    }

   }
 
   const DetRuleBuilder = async (objRule, DetLine, PermissionList, DetailTable) => { //rule row , data grid row , permission
     let rule = objRule.strRule;
 
     if (rule.includes("DET_TYPE")) {
       rule = rule.replaceAll("DET_TYPE", DetLine.strDET_TYPE);
     }
     if (rule.includes("DET_COMCODE")) {
       rule = rule.replaceAll("DET_COMCODE", DetLine.strDET_COMCODE);
     }
     if (rule.includes("DET_LOCCODE")) {
       rule = rule.replaceAll("DET_LOCCODE", DetLine.strDET_LOCCODE);
     }
     if (rule.includes("DET_SACODE")) {
       rule = rule.replaceAll("DET_SACODE", DetLine.strDET_SACODE);
     }
     if (rule.includes("DET_PROCODE")) {
       rule = rule.replaceAll("DET_PROCODE", DetLine.strDET_PROCODE);
     }
     if (rule.includes("DET_STOCKCODE")) {
       rule = rule.replaceAll("DET_STOCKCODE", DetLine.strDET_STOCKCODE);
     }
     if (rule.includes("DET_PRODESC")) {
       rule = rule.replaceAll("DET_PRODESC", DetLine.strDET_PRODESC);
     }
     if (rule.includes("DET_UNITQTY")) {
       rule = rule.replaceAll("DET_UNITQTY", DetLine.dcDET_UNITQTY);
     }
     if (rule.includes("DET_CS")) {
       rule = rule.replaceAll("DET_CS", FormatNumberTODecimal(DetLine.dcDET_CS));
     }
     if (rule.includes("DET_EXPDATE")) {
       rule = rule.replaceAll("DET_EXPDATE", DetLine.dtDET_EXPDAET);
     }
     if (rule.includes("DET_EXPBATCH")) {
       rule = rule.replaceAll("DET_EXPBATCH", DetLine.strDET_EXPBATCH);
     }
     if (rule.includes("DET_SYSQTY")) {
       rule = rule.replaceAll("DET_SYSQTY", FormatNumberTODecimal(DetLine.dcDET_SYSQTY));
     }
     if (rule.includes("DET_CASEQTY")) {
       rule = rule.replaceAll("DET_CASEQTY", FormatNumberTODecimal(DetLine.dcDET_CASEQTY));
     }
     if (rule.includes("DET_UNIT")) {
       rule = rule.replaceAll("DET_UNIT", FormatNumberTODecimal(DetLine.strDET_UNIT));
     }
     if (rule.includes("DET_FCASEQTY")) {
       rule = rule.replaceAll("DET_FCASEQTY", FormatNumberTODecimal(DetLine.dcDET_FCASEQTY));
     }
     if (rule.includes("DET_FUNITQTY")) {
       rule = rule.replaceAll("DET_FUNITQTY", FormatNumberTODecimal(DetLine.dcDET_FUNITQTY));
     }
     if (rule.includes("DET_BALQTY")) {
       rule = rule.replaceAll("DET_BALQTY", FormatNumberTODecimal(DetLine.dcDET_BALQTY));
     }
     if (rule.includes("DET_VARQTY")) {
       rule = rule.replaceAll("DET_VARQTY", FormatNumberTODecimal(DetLine.dcDET_VARQTY));
     }
     if(rule.includes("DET_SPRICE_OLD")){
      rule = rule.replaceAll("DET_SPRICE_OLD", FormatNumberTODecimal(DetLine.dcDET_SPRICE_OLD));
     }
     if(rule.includes("DET_CPRICE_OLD")){
       rule = rule.replaceAll("DET_CPRICE_OLD", FormatNumberTODecimal(DetLine.dcDET_CPRICE_OLD));
     }     
     if (rule.includes("DET_SPRICE")) {
       rule = rule.replaceAll("DET_SPRICE", FormatNumberTODecimal(DetLine.dcDET_SPRICE));
     }
     if (rule.includes("DET_CPRICE")) {
       rule = rule.replaceAll("DET_CPRICE", FormatNumberTODecimal(DetLine.dcDET_CPRICE));
     }
     if (rule.includes("DET_ACOST")) {
       rule = rule.replaceAll("DET_ACOST", FormatNumberTODecimal(DetLine.dcDET_ACOST));
     }
     if (rule.includes("DET_APRICE")) {
       rule = rule.replaceAll("DET_APRICE", FormatNumberTODecimal(DetLine.dcDET_APRICE));
     }
     if (rule.includes("DET_DISCPER")) {
       rule = rule.replaceAll("DET_DISCPER", FormatNumberTODecimal(DetLine.dcDET_DISCPER));
     }
     if (rule.includes("DET_DISCAMT")) {
       rule = rule.replaceAll("DET_DISCAMT", FormatNumberTODecimal(DetLine.dcDET_DISCAMT));
     }
     if (rule.includes("DET_AMOUNT")) {
       rule = rule.replaceAll("DET_AMOUNT", FormatNumberTODecimal(DetLine.dcDET_AMOUNT));
     }
     if (rule.includes("DET_REMCODE")) {
       rule = rule.replaceAll("DET_REMCODE", DetLine.strDET_REMCODE);
     }

     if (rule.includes("AND")) {
       rule = rule.replaceAll("AND", "&&");
     }
     if (rule.includes("OR")) {
       rule = rule.replaceAll("OR", "||");
     }
     if (rule.includes("\r\n")) {
       rule = rule.replaceAll("\r\n", "");
     }
 
     try{
      
      if (eval(rule)) {
 
        if (PermissionList && PermissionList.strMenuAccessRight == false) {
          let objRuleLine = []
          objRuleLine = remoteRequest;
          objRuleLine.push({
            strRA_TXN_TYPE: type,
            strRA_TXN_NO: "NAN",
            strRA_TXN_LOCATION: LocationCode,
            dtRA_TXN_DATE: new Date(),
            dcRA_TXN_VALUE: parseFloat(txNetAmount),
            strRA_TXN_PERMISSION: `${menuCode}-${objRule.intID}`,
            strRA_REQUEST: RuleDescBuilder(objRule.strCheckingDesc, DetLine),
            intRA_PRIORITY: objRule.intPriority,
            shrtRA_APPROVED: 0,
            strRA_APPRIVED_BY: "",
            strRA_REMARKS: "",
          })
          SetRemoteRequest(objRuleLine)
        }
  
      }
      
      return true;
      
     }catch(error){
        console.error("Error in DetRuleBuilder:", error);
        return false;
     }

   }
   //*End Rule Builder */
 
   //**Rule Description Builder */
   const RuleDescBuilder = (rule, DetTable = {}) => {
     if (rule.includes("HED_TYPE")) {
       rule = rule.replaceAll("HED_TYPE", type);
     }
     if (rule.includes("HED_REFTYPE")) {
       rule = rule.replaceAll("HED_REFTYPE", refTypeSelected);
     }
     if (rule.includes("HED_RUNNO")) {
       rule = rule.replaceAll("HED_RUNNO", docNo.length > 0 ? docNo : "NAN");
     }
     if (rule.includes("HED_LOCFROM")) {
       rule = rule.replaceAll("HED_LOCFROM", fromLocationSelect);
     }
     if (rule.includes("HED_LOCTO")) {
       rule = rule.replaceAll("HED_LOCTO", toLocationSelect);
     }
     if (rule.includes("HED_LOCDEL")) {
       rule = rule.replaceAll("HED_LOCDEL", deliLocationSelect);
     }
     if (rule.includes("HED_PRICEMODE")) {
       rule = rule.replaceAll("HED_PRICEMODE", priceModeSelect);
     }
     if (rule.includes("HED_CUSCODE")) {
       rule = rule.replaceAll("HED_CUSCODE", customerSelect);
     }
     if (rule.includes("HED_SUPCODE")) {
       rule = rule.replaceAll("HED_SUPCODE", supplierSelect);
     }
     if (rule.includes("HED_REFNO")) {
       rule = rule.replaceAll("HED_REFNO", RefCode);
     }
     if (rule.includes("HED_REF1")) {
       rule = rule.replaceAll("HED_REF1", remarks1);
     }
     if (rule.includes("HED_REF2")) {
       rule = rule.replaceAll("HED_REF2", remarks2);
     }
     if (rule.includes("HED_SELLAMT")) {
       rule = rule.replaceAll("HED_SELLAMT", txNetAmount.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_GROSSAMT")) {
       rule = rule.replaceAll("HED_GROSSAMT", GrossTotal.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_DISCPER")) {
       rule = rule.replaceAll("HED_DISCPER", txDiscount.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_ITAXAMT")) {
       rule = rule.replaceAll("HED_ITAXAMT", txTaxInc.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_ETAXAMT")) {
       rule = rule.replaceAll("HED_ETAXAMT", txTaxExc.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_ADDAMT")) {
       rule = rule.replaceAll("HED_ADDAMT", txAddition.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_DEDAMT")) {
       rule = rule.replaceAll("HED_DEDAMT", txDeduction.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_NETAMT")) {
       rule = rule.replaceAll("HED_NETAMT", txNetAmount.toLocaleString(undefined, {
         maximumFractionDigits: txnDecimalAmt,
         minimumFractionDigits: 2,
       }));
     }
     if (rule.includes("HED_RECCOUNT")) {
       rule = rule.replaceAll("HED_RECCOUNT", recCount);
     }
     if (rule.includes("HED_REFCOUNT")) {
       rule = rule.replaceAll("HED_REFCOUNT", 0);
      }  
      if (rule.includes("HED_PROCESSED")) {
       rule = rule.replaceAll("HED_PROCESSED", txn.intTX_TEMPSAVE == 1 ? transactionProcess : 1);
      }
      if (rule.includes("DET_TYPE")) {
         rule = rule.replaceAll("DET_TYPE", DetTable.strDET_TYPE);
       }
       if (rule.includes("DET_COMCODE")) {
         rule = rule.replaceAll("DET_COMCODE", DetTable.strDET_COMCODE);
       }
       if (rule.includes("DET_LOCCODE")) {
         rule = rule.replaceAll("DET_LOCCODE", DetTable.strDET_LOCCODE);
       }
       if (rule.includes("DET_SACODE")) {
         rule = rule.replaceAll("DET_SACODE", DetTable.strDET_SACODE);
       }
       if (rule.includes("DET_PROCODE")) {
         rule = rule.replaceAll("DET_PROCODE", DetTable.strDET_PROCODE);
       }
       if (rule.includes("DET_STOCKCODE")) {
         rule = rule.replaceAll("DET_STOCKCODE", DetTable.strDET_STOCKCODE);
       }
       if (rule.includes("DET_PRODESC")) {
         rule = rule.replaceAll("DET_PRODESC", DetTable.strDET_PRODESC);
       }
       if (rule.includes("DET_CS")) {
         rule = rule.replaceAll("DET_CS", DetTable.dcDET_CS);
       }
       if (rule.includes("DET_EXPDATE")) {
         rule = rule.replaceAll("DET_EXPDATE", DetTable.dtDET_EXPDAET);
       }
       if (rule.includes("DET_EXPBATCH")) {
         rule = rule.replaceAll("DET_EXPBATCH", DetTable.strDET_EXPBATCH);
       }
       if (rule.includes("DET_SYSQTY")) {
         rule = rule.replaceAll("DET_SYSQTY", DetTable.dcDET_SYSQTY);
       }
       if (rule.includes("DET_CASEQTY")) {
         rule = rule.replaceAll("DET_CASEQTY", DetTable.dcDET_CASEQTY);
       }
       if (rule.includes("DET_UNITQTY")) {
         rule = rule.replaceAll("DET_UNITQTY", DetTable.dcDET_UNITQTY);
       }
       if (rule.includes("DET_UNIT")) {
         rule = rule.replaceAll("DET_UNIT", DetTable.strDET_UNIT);
       }
       if (rule.includes("DET_FCASEQTY")) {
         rule = rule.replaceAll("DET_FCASEQTY", DetTable.dcDET_FCASEQTY);
       }
       if (rule.includes("DET_FUNITQTY")) {
         rule = rule.replaceAll("DET_FUNITQTY", DetTable.dcDET_FUNITQTY);
       }
       if (rule.includes("DET_BALQTY")) {
         rule = rule.replaceAll("DET_BALQTY", DetTable.dcDET_BALQTY);
       }
       if (rule.includes("DET_VARQTY")) {
         rule = rule.replaceAll("DET_VARQTY", DetTable.dcDET_VARQTY);
       }
       if(rule.includes("DET_SPRICE_OLD")){
        rule = rule.replaceAll("DET_SPRICE_OLD", DetTable.dcDET_SPRICE_OLD);
        }
       if(rule.includes("DET_CPRICE_OLD")){
         rule = rule.replaceAll("DET_CPRICE_OLD", DetTable.dcDET_CPRICE_OLD);
       }
       if (rule.includes("DET_SPRICE")) {
         rule = rule.replaceAll("DET_SPRICE", DetTable.dcDET_SPRICE);
       }
       if (rule.includes("DET_CPRICE")) {
         rule = rule.replaceAll("DET_CPRICE", DetTable.dcDET_CPRICE);
       }
       if (rule.includes("DET_ACOST")) {
         rule = rule.replaceAll("DET_ACOST", DetTable.dcDET_ACOST);
       }
       if (rule.includes("DET_APRICE")) {
         rule = rule.replaceAll("DET_APRICE", DetTable.dcDET_APRICE);
       }
       if (rule.includes("DET_DISCPER")) {
         rule = rule.replaceAll("DET_DISCPER", DetTable.dcDET_DISCPER);
       }
       if (rule.includes("DET_DISCAMT")) {
         rule = rule.replaceAll("DET_DISCAMT", DetTable.dcDET_DISCAMT);
       }
       if (rule.includes("DET_AMOUNT")) {
         rule = rule.replaceAll("DET_AMOUNT", DetTable.dcDET_AMOUNT);
       }
       if (rule.includes("DET_REMCODE")) {
         rule = rule.replaceAll("DET_REMCODE", DetTable.strDET_REMCODE);
       }
      if (rule.includes("\r\n")) {
          rule = rule.replaceAll("\r\n", "");
      }
 
     return rule;
   }
   //**End Rule Description Builder */
 
   //**Start Send Permission Request */

   const SendPermissionRequest = async (DocumentNo) => {
     var obj = JSON.parse(localStorage.getItem("authUser"))
     let LogUserType = obj[2]
     let LocationCode = obj[3]
     let LocationName = obj[4]
     var Body = {
       "strUserID": LogUserType,
       "strLocCode": LocationCode,
       "strLocName": LocationName,
       "strDocNo": DocumentNo,
       "strMenuCode": menuCode,
       "strTransaction": type
     }
     SendFCM(Body);
   }
   //**End Send Permisstion Request */
 
   //if items has to generate using subdoc location use this function
   function GenerateItemUnitCountFromSubdoc() {
 
     var filteredSubdocs = subDocs.filter(subdoc => subdoc.loC_CODE === fromLocationSelect);
 
     var newGrid = DataRow.map(item => {
       var subdocItem = filteredSubdocs.find(subdoc => subdoc.prO_CODE === item.strDET_PROCODE);
       return subdocItem ? { ...item, dcDET_UNITQTY: subdocItem.qty } : item;
     });
 
     TotalLineAmtCalcualtion(newGrid);
 
   }
 
 
   function ProductErrorModleToggle() {
     setProductErrorToggle(!productErrorToggle)
   }
 
   function ProductSIHChangesToggleFunc() {
     setProductSIHChangesToggle(!productSIHChangesToggle)
   }
 
 
   //*Ref code on blur */
   const RefCodeOnBlur = async (runno, loc = "") => {
     if (runno == "") return
 
     var barcodeElement = document.getElementById("ScanBarCode");
     if (barcodeElement) {
       barcodeElement.value = "";
     }
 
     if (fromLocationSelect == '' && txn.intTX_SHOWVAR == 0) {
       setAlertDescription("Please Select Location Before Load The Reference Document !")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       SetRefCode("")
       return;
     }
 
     if (fromLocationSelect == "") {
       setAlertDescription("Please Select From Location Before Load The Reference Document !")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       SetRefCode("")
       return;
     }
 
     if (toLocationSelect == "" && txn.strTX_DESTINV != 'N' && txn.strTX_DESTINV != '') {
       setAlertDescription("Please Select To Location Before Load The Reference Document !")
       setAlertConfirmOption(100)
       setshowCancel(false)
       setsweetAlertShow(true)
       setBtnYes("Ok")
       SetRefCode("")
       return;
     }
 

       SetTaxDetails([])
 
        try{
        
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Loading Data...")

        const refTxnData = await GetTxn(refTypeSelected)
        setRefStockFreeze(refTxnData.intTX_STOCKFREEZE == 1 ? true : false)

          const response = await fetch(
            `${ApiURL}txn/single/refTxn`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
              body: JSON.stringify({
                txnType: type,
                refTxnType: refTypeSelected,
                fromLoc: fromLocationSelect,
                toLoc: toLocationSelect,
                runnumber: runno,
              }),
            }
          );
      
          const responseData = await response.json();

          const referenceDoc = responseData.data

          if(responseData.success){
            if (referenceDoc.strHED_RUNNO == null) {
              setAlertDescription(`Refence No. ${runno} is not found!`)
              setAlertConfirmOption(100)
              setshowCancel(false)
              setsweetAlertShow(true)
              setBtnYes("Ok")
              SetRefCode("")
              SetLoadingAlert(false)
              return
            }
  
            if (txn.intTX_REFCHKCANCEL == 1 && referenceDoc.blHED_CANCELLED == 1) {
              SetRefCode("")
              displayAlertMessage("danger", `Selected TXN No. ${referenceDoc.strHED_RUNNO} is Cancelled !`)
              SetLoadingAlert(false)
              return
            }
 
            if (txn.intTX_SKIP_FULLYUSED == 0 && referenceDoc.blHED_FULLYUSED == 1) {
              SetRefCode("")
              displayAlertMessage("danger", `Selected TXN No. ${referenceDoc.strHED_RUNNO} is Fully Used !`)
              SetLoadingAlert(false)
              return
            }
  
            // const doyou = confirm(`Do you want to load the data from ${referenceDoc.strHED_RUNNO} ?`)
             debugger
            if (refTxnData.intTX_VALIDFROMDATE == 1 && refTxnData.intTX_VALIDTODATE == 1) {
              if (referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) != "1990-01-01") {
                var todayDate = new Date().toISOString().slice(0, 10)
                // if (referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) > todayDate || referenceDoc.dtHED_VALIDTODATE.slice(0, 10) < todayDate) {
                if (referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) > todayDate || referenceDoc.dtHED_VALIDTODATE.slice(0, 10) < todayDate) {
                  setAlertDescription(`Refence No. ${referenceDoc.strHED_RUNNO} is not within the valid date range!  From ${referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10)} to ${referenceDoc.dtHED_VALIDTODATE.slice(0, 10)}`)
                  setAlertConfirmOption(100)
                  setshowCancel(false)
                  setsweetAlertShow(true)
                  setBtnYes("Ok")
                  SetRefCode("")
                  SetLoadingAlert(false)
                  return
                }
              }
            }
  
             //  if (txn.intTX_SCANBARCODE == 0) {
              if (txn.intTX_REFCHKPROC == 1 && referenceDoc.blHED_PROCESSED == true) {
                SetToLocationSelect(txn.intTX_REMOVE_REFLOC_VALIDATION == 1 || txn.intTX_REFE_LOCA == 1 ? toLocationSelect : referenceDoc.strHED_LOCTO)
                SetDeliLocationSelect(referenceDoc.strHED_LOCDEL)
                SetCustomerSelect(referenceDoc.strHED_CUSCODE)
                SetSalesAssistantSelect("")
                SetCustomerSelectName(referenceDoc.strCM_FULLNAME)
                SetValidFromDate(txn.intTX_UNLOAD_VALIDFROMDATE == 1 ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10))
                SetValidToDate(txn.intTX_UNLOAD_VALIDTODATE == 1 ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10))
                SetSupplierSelect(referenceDoc.strHED_SUPCODE)
                SetSupplierSelectName(referenceDoc.strSM_NAME)
  
                const response = await getTransactionTax(txn.intTX_TAXH_CODE, referenceDoc.strHED_SUPCODE != "" ? referenceDoc.strHED_SUPCODE : referenceDoc.strHED_CUSCODE, type)
                await CalculateTaxAmount(referenceDoc.newTaxDetails, SetTaxtTable, response.data, txnDecimalAmt)
  
                setTxnTaxTypes(response.data)
  
  
                SetTxDiscount(referenceDoc.decHED_DISCPER)
  
                const setLineData = referenceDoc.objTXN_DETREMDETSAVE.map(r => ({
                  LineNo: r.intRDET_LINENO,
                  remark: r.strRDET_REMARK,
                  key: r.intRDET_REMLINE
                }));
  
                SetTaxLineRemarks(setLineData)
  
                setTimeout(async () => {
                  getGridTable(referenceDoc.objTXN_DETSAVE)
                  SetRefDataRow(referenceDoc.objTXN_DETSAVE)
                }, 500);
  
  
                if (txn.intTX_FROMHO == 0) {
                  let dataset = await getSubDocs(referenceDoc.objTXN_DETSUBDOCS)
  
                  if (dataset.status == 1) {
                    setSubDocs(dataset.subdocsResponse)
                  }
  
                  if (dataset.status == 1 && dataset.subdocsResponse.length > 0) {
  
                    setAlertDescription("Do you wish to fetch details related to current location ?")
                    setAlertConfirmOption(10)
                    setsweetAlertShow(true)
  
                  }
                }
                if (txn.intTX_LOADREF1_FROMREFDOC == 1) {
                  SetRemarks1(referenceDoc.strHED_REF1)
                }
  
                if (txn.intTX_LOADREMHED_FROMREFDOC == 1) {
                  SetRemHedDataRow(referenceDoc.objTXN_DETREMHEDSAVE.length > 0 ? referenceDoc.objTXN_DETREMHEDSAVE : [{ id: 1, strRHED_REMARK: "" }])
                }
  
                const isRef2Available = summaryRemarksList.find((item) => item.value == referenceDoc.strHED_REF2)
                if (isRef2Available) {
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                } else {
                  const currentRemarkList = summaryRemarksList
                  currentRemarkList.push({ label: referenceDoc.strHED_REF2DESC, value: referenceDoc.strHED_REF2 ,reqTxnRef1:false})
                  setSummaryRemarksList(currentRemarkList)
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                }
  
              } else if (txn.intTX_REFCHKPROC == 0 && referenceDoc.blHED_PROCESSED == false) {
  
                SetToLocationSelect(txn.intTX_REMOVE_REFLOC_VALIDATION == 1 || txn.intTX_REFE_LOCA == 1 ? toLocationSelect : referenceDoc.strHED_LOCTO)
                SetDeliLocationSelect(referenceDoc.strHED_LOCDEL)
                SetCustomerSelect(referenceDoc.strHED_CUSCODE)
                SetSalesAssistantSelect("")
                SetCustomerSelectName(referenceDoc.strCM_FULLNAME)
                SetValidFromDate(txn.intTX_UNLOAD_VALIDFROMDATE == 1 ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10))
                SetValidToDate(txn.intTX_UNLOAD_VALIDTODATE == 1 ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10))
                SetSupplierSelect(referenceDoc.strHED_SUPCODE)
                SetSupplierSelectName(referenceDoc.strSM_NAME)
  
                const response = await getTransactionTax(txn.intTX_TAXH_CODE, referenceDoc.strHED_SUPCODE != "" ? referenceDoc.strHED_SUPCODE : referenceDoc.strHED_CUSCODE, type)
                await CalculateTaxAmount(referenceDoc.newTaxDetails, SetTaxtTable, response.data, txnDecimalAmt)
  
                setTxnTaxTypes(response.data)
  
  
                SetTxDiscount(referenceDoc.decHED_DISCPER)
  
                const setLineData = referenceDoc.objTXN_DETREMDETSAVE.map(r => ({
                  LineNo: r.intRDET_LINENO,
                  remark: r.strRDET_REMARK,
                  key: r.intRDET_REMLINE
                }));
  
                SetTaxLineRemarks(setLineData)
  
                setTimeout(async () => {
                  getGridTable(referenceDoc.objTXN_DETSAVE)
                  SetRefDataRow(referenceDoc.objTXN_DETSAVE)
                }, 500);
  
  
                if (txn.intTX_FROMHO == 0) {
                  let dataset = await getSubDocs(referenceDoc.objTXN_DETSUBDOCS)
  
                  if (dataset.status == 1) {
                    setSubDocs(dataset.subdocsResponse)
                  }
  
                  if (dataset.status == 1 && dataset.subdocsResponse.length > 0) {
  
                    setAlertDescription("Do you wish to fetch details related to current location ?")
                    setAlertConfirmOption(10)
                    setsweetAlertShow(true)
  
                  }
                }
                if (txn.intTX_LOADREF1_FROMREFDOC == 1) {
                  SetRemarks1(referenceDoc.strHED_REF1)
                }
  
                if (txn.intTX_LOADREMHED_FROMREFDOC == 1) {
                  SetRemHedDataRow(referenceDoc.objTXN_DETREMHEDSAVE.length > 0 ? referenceDoc.objTXN_DETREMHEDSAVE : [{ id: 1, strRHED_REMARK: "" }])
                }
  
                const isRef2Available = summaryRemarksList.find((item) => item.value == referenceDoc.strHED_REF2)
                if (isRef2Available) {
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                } else {
                  const currentRemarkList = summaryRemarksList
                  currentRemarkList.push({ label: referenceDoc.strHED_REF2DESC, value: referenceDoc.strHED_REF2 ,reqTxnRef1:false})
                  setSummaryRemarksList(currentRemarkList)
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                }
  
  
              } else if (txn.intTX_REFCHKCANCEL == 1 && referenceDoc.blHED_CANCELLED == false) {
  
                SetToLocationSelect(txn.intTX_REMOVE_REFLOC_VALIDATION == 1 || txn.intTX_REFE_LOCA == 1 ? toLocationSelect : referenceDoc.strHED_LOCTO)
                SetDeliLocationSelect(referenceDoc.strHED_LOCDEL)
                SetCustomerSelect(referenceDoc.strHED_CUSCODE)
                SetSalesAssistantSelect("")
                SetValidFromDate(txn.intTX_UNLOAD_VALIDFROMDATE == 1 ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDFROMDATE.slice(0, 10))
                SetValidToDate(txn.intTX_UNLOAD_VALIDTODATE == 1 ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10) == "1990-01-01" ? "" : referenceDoc.dtHED_VALIDTODATE.slice(0, 10))
                SetSupplierSelect(referenceDoc.strHED_SUPCODE)
                const response = await getTransactionTax(txn.intTX_TAXH_CODE, referenceDoc.strHED_SUPCODE != "" ? referenceDoc.strHED_SUPCODE : referenceDoc.strHED_CUSCODE, type)
                await CalculateTaxAmount(referenceDoc.newTaxDetails, SetTaxtTable, response.data, txnDecimalAmt)
                setTxnTaxTypes(response.data)
                SetSupplierSelectName(referenceDoc.strSM_NAME)
                SetCustomerSelectName(referenceDoc.strCM_FULLNAME)
  
                //SetTaxDetails(referenceDoc.objTXN_DETTAXSAVE)
  
                const setLineData = referenceDoc.objTXN_DETREMDETSAVE.map(r => ({
                  LineNo: r.intRDET_LINENO,
                  remark: r.strRDET_REMARK,
                  key: r.intRDET_REMLINE
                }));
  
                SetTaxLineRemarks(setLineData)
  
                getGridTable(referenceDoc.objTXN_DETSAVE)
                SetRefDataRow(referenceDoc.objTXN_DETSAVE)
  
                if (txn.intTX_FROMHO == 0) {
                  let dataset = await getSubDocs(referenceDoc.objTXN_DETSUBDOCS)
  
                  if (dataset.status == 1) {
                    setSubDocs(dataset.subdocsResponse)
                  }
                  if (dataset.subdocsResponse.length > 0) {
  
                    setAlertDescription("Do you wish to fetch details related to current location ?")
                    setAlertConfirmOption(10)
                    setsweetAlertShow(true)
  
                  }
                }
  
                if (txn.intTX_LOADREF1_FROMREFDOC == 1) {
                  SetRemarks1(referenceDoc.strHED_REF1)
                }
  
                if (txn.intTX_LOADREMHED_FROMREFDOC == 1) {
                  SetRemHedDataRow(referenceDoc.objTXN_DETREMHEDSAVE.length > 0 ? referenceDoc.objTXN_DETREMHEDSAVE : [{ id: 1, strRHED_REMARK: "" }])
                }
  
                const isRef2Available = summaryRemarksList.find((item) => item.value == referenceDoc.strHED_REF2)
                if (isRef2Available) {
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                } else {
                  const currentRemarkList = summaryRemarksList
                  currentRemarkList.push({ label: referenceDoc.strHED_REF2DESC, value: referenceDoc.strHED_REF2 , reqTxnRef1: false })
                  setSummaryRemarksList(currentRemarkList)
                  SetRemarks2(referenceDoc.strHED_REF2)
                  SetReferenceRemark(referenceDoc.strHED_REF2)
                }
  
              } else if (txn.intTX_REFCHKPROC == 1 && referenceDoc.blHED_PROCESSED == false) {
  
                SetRefCode("")
                // setAlertColor("warning")
                // setAlertMsg(`Selected TXN No. ${runno} is Not Processed !`)
                // setShow(true)
                // setTimeout(() => {
                //   setShow(false)
                // }, time)
                displayAlertMessage("warning", `Selected TXN No. ${runno} is Not Processed !`)
                SetLoadingAlert(false)
                return
  
              } else if (txn.intTX_REFCHKCANCEL == 1 && referenceDoc.blHED_CANCELLED == true) {
  
                SetRefCode("")
                displayAlertMessage("warning", `Selected TXN No. ${runno} is Cancelled !`)
                SetLoadingAlert(false)
                return
  
              } else {
                //SetRefCode("")
              }

              if (referenceDoc.strHED_SUPCODE != "") {
                const { success, data, message } = await GetSupplierDetails(referenceDoc.strHED_SUPCODE, type)
                if (success) {
                  setTimeout(() => {
                    SetSupplierContribution(data.contribution)
                    SetSkipSupplierApproval(data.skipApproval)
                  }, 1000);
  
  
                } else {
                  setTimeout(() => {
                    SetSupplierContribution(0)
                    SetSkipSupplierApproval(false)
                  }, 1000);
                }
              }
  
          }else{
            SetRefCode("")
            displayAlertMessage("danger", `${responseData.message}`)
          }

          }catch(error){
            console.log(error)
          }finally{
            SetLoadingAlert(false)
          }
 
   }
   //* End Ref Code OnBlur */
 
 
   async function AutoOrder() { //AutoOrder Function
 
     if (supplierSelect == "") {
       displayAlertMessage("danger", "Please Select Supplier")
       return
     }
 
     if (fromLocationSelect == "") {
       displayAlertMessage("danger", "Please Select Location")
       return
     }

     setGeneralFields(prev=> ({
      ...prev,
      autoOrderShow: true
      }))

   }


   async function getAutoOrderData(selectionData){

      try {
        SetLoadingAlert(true)
        SetLoadingAlerttitle("Getting Auto Order...")
        //get details from auto order 
        const detailsAuto = await GetAutoOrder(supplierSelect, fromLocationSelect,selectionData.fromDate,selectionData.toDate,selectionData.numDays,type)

        //if auto order is success 
        if (detailsAuto.isSuccess) {
          //detailsAuto.data has dataset of auto order. but we need to add some more fields to that dataset
          //so we are using map function to add some more fields to that dataset
          //we are adding id, disable fields to that dataset
          //id is used to identify the row in the grid
          //disable is used to disable the row in the grid

         const response = await getTransactionTax(txn.intTX_TAXH_CODE, supplierSelect, type)
         await CalculateTaxAmount(detailsAuto.tax, SetTaxtTable, response.data, txnDecimalAmt)

          var newGrid = detailsAuto.data.map((item, index) => {
            item.id = index + 1;
            item.disable = true;

            const caseQty = Math.floor(item.dcDET_UNITQTY / item.dcDET_CS); // Calculate caseQty once

            // Check if caseQty is valid and set default values if not
            if (isNaN(caseQty) || !Number.isFinite(caseQty)) {
              item.dcDET_UNITQTY = item.dcDET_UNITQTY;  // Retaining original value
            } else {
              if (txn.intTX_CASEQTY === 1 && txn.intTX_UNITQTY === 1) {
                item.dcDET_CASEQTY = caseQty;
                item.dcDET_UNITQTY -= caseQty * item.dcDET_CS;  // Update unit quantity
              } else if (txn.intTX_CASEQTY === 1) {
                item.dcDET_CASEQTY = caseQty;
                item.dcDET_UNITQTY = 0; // Set unit quantity to 0
              }
            }

            return item;
          });

          getGridTable(newGrid)

        }
     } catch (error) {
       SetLoadingAlert(false)
       console.log(error)
     }finally{
        SetLoadingAlert(false)
     }
   }

 
   //* handleEdit */
   const handleEdit = async () => {
 
     if (remoteData.length > 0 && docNo.length > 0) {
       const { approvalStatus, alertMessage } = await getApprovalStatusAndMessage(remoteData);
 
       if (approvalStatus === 0) {
         displayAlertMessage("warning", alertMessage || "Pending approvals should be approved or rejected before amending this document!");
         return;
       } else if (approvalStatus === 2) {
         displayAlertMessage("danger", alertMessage || "Sorry! Your request to approve was rejected. This document is not editable.");
         return;
       } else if (approvalStatus === 1 || approvalStatus === 3) {
         displayAlertMessage("info", alertMessage);
       }
 
       if (approvalStatus == 3) {
         SetDisableDet(false);
         SetdisabledDate(false);
         SetDateDisableFields(prevState => ({
            ...prevState,
            txtDate: true,
            validDate: true,
            validFromDate: txn.intTX_VALIDFROMDATE_EDITABLE_ON_UNPROCESS == 1 ? false : true,
            validToDate: true
          })
          )
         SetdisabledRemarks(false);
       } else {
         SetDisableDet(true);
         SetdisabledRemarks(true);
       }
 
       setSaveEnable(true);
     } else {
       SetdisabledDate(false);
       SetDateDisableFields(prevState => ({
        ...prevState,
        txtDate: true,
        validDate: true,
        validFromDate: txn.intTX_VALIDFROMDATE_EDITABLE_ON_UNPROCESS == 1 ? false : true,
        validToDate: true
      })
      )
       setSaveEnable(true);
       SetDisableDet(false);
       SetdisabledRemarks(false);
     }
 
   }
 
 
 
   //* End  */
   const PermissionLog = () => {
 
   }
 
   const UserPermission = operation => {
     const permissiondata = {
       strUsername: permissionName,
       strPassword: permissionPassword,
       strLocation: LocationCode,
       strMenuCode: operation == "underCost" ? "" : menuCode,
     }
 
     setPermissionName("")
     setPermissionPassword("")
     setReason("")
 
     fetch(`${ApiURL}login/userpermission`, {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
         Authorization: `Bearer ${authToken}`,
       },
       body: JSON.stringify(permissiondata),
     })
       .then(Response => {
         if (Response.status == "200") {
           Response.json().then(responseData => {
             let Access = responseData.data.strMenuAccessRight
             let Create = responseData.data.strMenuCreateRight
             let Delete = responseData.data.strMenuDeleteRight
             let Modify = responseData.data.strMenuModifyRight
             let Print = responseData.data.strMenuPrintRight
             let Process = responseData.data.strMenuProcessRight
 
             if (operation == "Save") {
               if (Create == true) {
 
                 if (AlertConfirmOption == 1) {
                   SaveTransaction(txnProcess)
                 } else {
                   SaveTransaction(txnProcess)
                 }
         
               } else if (Modify == true) {
                 if (AlertConfirmOption == 1) {
                   SaveTransaction(txnProcess)
                 } else {
                   SaveTransaction(txnProcess)
                 }
  
               } else {
                 if (operation == "Save" && addNew == true) {
                   displayAlertMessage("danger", "This user dosen't have permission to save")
                   return
                 } else {
                   displayAlertMessage("danger", "This user dosen't have permission to edit")
                   return
                 }
               }
             } else if (operation == "Delete") {
               if (Delete == true) {
                 CancelCurrenctTransaction()
               } else {
                 displayAlertMessage("danger", "This user dosen't have permission to delete")
                 return
               }
             } else if (operation == "Print") {
               if (Print == true) {
                 setprintoptionShow(true)
               } else {
                 displayAlertMessage("danger", "This user dosen't have permission to print")
                 return
               }
             } else if (operation == "underCost") {
               if (Access == true) {
                 setUc(true)
               } else {
                 displayAlertMessage("danger", "This user don't have permission to under cost")
                 return
 
               }
             }
           })
         } else if (Response.status == "400") {
           Response.json().then(responseData => {
             setErrorMsg(responseData.msg)
           })
 
           setPermissionName("")
           setPermissionPassword("")
 
           displayAlertMessage("danger", "Oops something went wrong !")
         } else if (Response.status == "403") {
 
           setPermissionName("")
           setPermissionPassword("")
           displayAlertMessage("danger", "You have not Permission to make changes !")
         } else if (Response.status == "404") {
 
           setPermissionName("")
           setPermissionPassword("")
           displayAlertMessage("danger", "Password or User Name is Invalid !")
         } else {
           ClearItem()
         }
       })
       .catch(error => {
         console.log(error.message)
       })
 
     //notification disable function
 
   }
 
   //Cancel Currenct Transaction
   const CancelCurrenctTransaction = async () => {
     var obj = JSON.parse(localStorage.getItem("authUser"))
     let LogUserType = obj[2]
     var LocationCode = obj[3]
     var CompanyCode = obj[5]
     let body = {
       "strUser": LogUserType,
       "strLocation": LocationCode,
       "strCompany": CompanyCode,
       "strReason": Reason,
       "strType": type,
       "strDocoumentNo": docNo,
     }
     let data = await CancelTransaction(body);
     if (data == 1) {
       displayAlertMessage("success", "Document Cancelled Successfully !")
       ClearItem();
     } else if (data == -1) {
       displayAlertMessage("danger", "Can not cancel process document !")
     } else if (data == 2) {
       displayAlertMessage("danger", "This is a bin entry doucument , can not cancel !")
     } else {
       displayAlertMessage("danger", "Document Cancelled Failed !")
     }
   }
 
   const handlePrint = async option => {
     var option = option
 
     SetLoadingAlert(true)
     SetLoadingAlerttitle("Generating Report...")
 
     const ReportURL = window.Links.ReportURL
 
     await fetch(
       `${ReportURL}api/txn/report/${option == "PDF" ? 1 : 0}/${LogUserType}/${printDoc}/${type}`,
       {
         method: "GET",
         headers: {
           "Content-Type": "application/json",
           Authorization: `Bearer ${authToken}`,
         },
       }
     )
       .then(Response => Response.json())
       .then(responseData => {
         if (responseData.success == true) {
           PermissionLog()
           if (option == "PDF") {
             const msg = responseData.msg
             window.open(`${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`)
           }
           if (option == "XCEL") {
             const msg = responseData.msg
             window.open(`${ReportURL}temp_print/${msg.replace("\r\n", "")}.xls`)
           }
         }
         SetLoadingAlert(false)
       }).catch(error => {
         console.log(error.message)
         SetLoadingAlert(false)
       })
   }
 
 
 
 
 
   useEffect(async () => {
     var obj = JSON.parse(localStorage.getItem("authUser"))
     var LogUserType = obj[2]
     var LocationCode = obj[3]
     var CompanyCode = obj[5]
 
     var menuDetail = await getMenuDetails(window.location.pathname + "?" + type)
     var menu = menuDetail?.menuTag
     var parentname = menuDetail?.parentName
 
     SetParentName(parentname)
     setLocationCode(LocationCode)
     setLogUserType(LogUserType)
 
 
     var responseData = await getSelectedMasterPermissions(LogUserType, menu)
 
     if (!responseData.strMenuAccessRight) {
       history.push('/dashboard')
     }
 
     SetMenuCreate(responseData.strMenuCreateRight)
     SetMenuDelete(responseData.strMenuDeleteRight)
     SetMenuModify(responseData.strMenuModifyRight)
     SetMenuPrint(responseData.strMenuPrintRight)
     SetMenuName(responseData.strMenuName)
     SetMenuCode(responseData.strMenuTag)
     setPermissionReasonShow(responseData.strMenuReasonShow)
     setHelpUrl(responseData.strHelpUrl)
 
     if (txn.intTX_VALIDDAYS) {
       if (txndate) {
         var txnDat = new Date(txndate)
         var tomorrow = new Date(txndate)
         tomorrow.setDate(txnDat.getDate() + parseInt(txn.intTX_VALIDDAYS))
         setValidDay(tomorrow.toISOString().slice(0, 10))
       } else {
         //
         let dates = new Date()
         var tomorrow = new Date()
         tomorrow.setDate(dates.getDate() + parseInt(txn.intTX_VALIDDAYS))
         setValidDay(tomorrow.toISOString().slice(0, 10))
       }
     }
 
   }, [type])
 
 
   useEffect(() => {
     if (txn.intTX_VALIDDAYS) {
       if (txndate) {
         var txnDat = new Date(txndate)
         var tomorrow = new Date(txndate)
         tomorrow.setDate(txnDat.getDate() + parseInt(txn.intTX_VALIDDAYS))
         setValidDay(tomorrow.toISOString().slice(0, 10))
       } else {
         let dates = new Date()
         var tomorrow = new Date()
         tomorrow.setDate(dates.getDate() + parseInt(txn.intTX_VALIDDAYS))
         setValidDay(tomorrow.toISOString().slice(0, 10))
       }
     }
 
   }, [txndate])
 
 
   function mobileManToggle() {
     setMobileToggle(!mobileToggle)
   }
 
   async function handleMobileManRowClick(e) {
 
     mobileManToggle()
 
     if (txn.intTX_SUPPLIER == 1 && supplierSelect == "") {
       displayAlertMessage("danger", `Please Select Supplier !`)
       return
     }
 
     if (txn.intTX_SAVEINVOICE == 1 && customerSelect == "") {
       displayAlertMessage("danger", `Please Select Customer !`)
       return
     }
 
     try {
       SetLoadingAlert(true)
       SetLoadingAlerttitle("Getting Data...")
 
       const { detail, tax } = await MobileManTransaction(type, e.sC_USER, fromLocationSelect, e.sC_SHELFID, supplierSelect, customerSelect)

       await ModifyTaxGridFromMobileMan(txnTaxTypes, tax, detail, SetTaxtTable, txnDecimalAmt)
 
       setMobileMan({
        user: e.sC_USER,
        remark: e.sC_SHELFID,
       })

       setTimeout(() => {
         getGridTable(detail)
       }, 1000);
 
     } catch (error) {
       console.log(error)
     }finally{
        SetLoadingAlert(false)
     }
 
 
   }
 
 
   useEffect(async () => { //when datatable changes calculate from and to value
 
     if (txn.intTX_BOM == 1) {
       const { fromValue, toValue } = await calculateFromAndToValue(DataRow, proSelect, txn)
       setBomFromValue(fromValue)
       setBomToValue(toValue)
     }
 
   }, [DataRow])
 
 
   //Handle Favourite Button
   const handleFavourite = async () => {
     var response = await addtoFavourite(menuCode, LogUserType);
   }
 
 
   function displayAlertMessage(color, message) {
     setAlertColor(color)
     setAlertMsg(message)
     setShow(true)
 
     setTimeout(() => {
       setShow(false)
     }, time)
   }
 
 
 
   useEffect(() => {
     const handleKeyPress = (event) => {
       // Check if the pressed key is F2 (keyCode 113)
       if (event.keyCode === 113) {
         // Call your function here
         tog_xlarge()
       }
 
       //if left arrow key is pressed
       if (event.keyCode === 37 && event.ctrlKey) {
         // Call your function here
 
         setcustomActiveTab((prevTab) => {
           const activeTab = parseInt(prevTab, 10);
           if (activeTab - 1 == 0) {
             return "1";
           } else {
             return (activeTab - 1).toString();
           }
         });
       }
 
       //if right arrow key is pressed
       if (event.keyCode === 39 && event.ctrlKey) {
         // Call your function here
         // for some reason , tabList.length is not working here , so i used a variable to store the length of the tabList 
         // I think it is because of the asynchronous nature of the setTabList function
         // so when the function is called , the tabList.length is not updated yet
         // I used SetTabList to get the length of the tabList and store it in a variable called tabLength
         let tabLength = 0;
 
         SetTabList((prevTab) => {
           tabLength = prevTab.length;
           return prevTab;
         })
 
         setcustomActiveTab((prevTab) => {
           const activeTab = parseInt(prevTab, 10);
 
           if (activeTab + 1 == tabLength || activeTab + 1 > tabLength) {
             return tabLength.toString();
           } else {
             return (activeTab + 1).toString();
           }
         });
       }
 
     };
 
     // Add event listener when the component mounts
     document.addEventListener('keydown', handleKeyPress);
 
     // Clean up the event listener when the component unmounts
     return () => {
       document.removeEventListener('keydown', handleKeyPress);
     };
   }, []); // Empty dependency array ensures the effect runs once when the component mounts
 
 
   async function getSupplier(supCode) {
 
     if (supCode == "") {
       setTxnTaxTypes([])
       return
     }
 
     const { success, data, message } = await GetSupplierDetails(supCode, type)
     if (success) {
       SetSupplierSelect(data.code)
       SetSupplierSelectName(data.name)
       SetSupplierContribution(data.contribution)
       SetSkipSupplierApproval(data.skipApproval)
       const response = await getTransactionTax(txn.intTX_TAXH_CODE, data.code, type)
       setTxnTaxTypes(response.data)
     } else {
       SetSupplierSelectName("")
       SetSupplierSelect("")
       SetSupplierContribution(0)
       SetSkipSupplierApproval(false)
       setTxnTaxTypes([])
       if (txn.strTX_SUPPLIERGRP == "") {
         displayAlertMessage("danger", message)
       } else {
         displayAlertMessage("danger", `Supplier not found under this group ${txn.strTX_SUPPLIERGRP} !`)
       }
     }
   }
 
   async function getCustomer(cusCode) {
 
     if (cusCode == "") return
 
     const { success, data, message } = await GetCustomerDetails(cusCode, type)
     if (success) {
       SetCustomerSelect(data.code)
       SetCustomerSelectName(data.name)
       const response = await getTransactionTax(txn.intTX_TAXH_CODE, data.code, type)
       setTxnTaxTypes(response.data)
     } else {
       SetCustomerSelectName("")
       SetCustomerSelect("")
       setTxnTaxTypes([])
       if (txn.strTX_CUSTOMERGRP == "") {
         displayAlertMessage("danger", message)
       } else {
         displayAlertMessage("danger", `Customer not found under this group ${txn.strTX_CUSTOMERGRP} !`)
       }
     }
 
   }
 
 
   async function getSalesAssist(saCode) {
 
     if (saCode == "") return
 
     const { success, data } = await GetSalesAssistDetails(saCode)
     if (success) {
       if (data.status) {
         SetSalesAssistantSelect(data.code)
         SetSalesAssistantSelectName(data.fullName)
       } else {
         displayAlertMessage("danger", `${txn.strTX_SALESBYCAPTION == "" ? "Sales Assist" : txn.strTX_SALESBYCAPTION} not active !`)
       }
     } else {
       SetSalesAssistantSelect("")
       SetSalesAssistantSelectName("")
       displayAlertMessage("danger", `${txn.strTX_SALESBYCAPTION == "" ? "Sales Assist" : txn.strTX_SALESBYCAPTION} not found !`)
     }
   }
 
 
   async function getFinishPro(proCode) {
 
     if (proCode == "") return
 
     const { success, data } = await GetProduct(proCode, LocationCode)
     if (success) {
       if (data.isActive) {
         SetProSelect(data.strProductCode)
         SetProSelectName(data.strProductDesc)
       } else {
         SetProSelect("")
         SetProSelectName("")
         displayAlertMessage("danger", `Product not active !`)
       }
     } else {
       SetProSelect("")
       SetProSelectName("")
       displayAlertMessage("danger", `Product not found !`)
     }
   }
 
 
   async function getSelectedBOM(bomCode) {
 
     if (fromLocationSelect == "") {
       displayAlertMessage("danger", `Please select From Location !`)
       return
     }
 
     if (bomCode == "") return
     SetLoadingAlert(true)
     SetLoadingAlerttitle("Loading Data...")
     const { success, data } = await GetBOM(bomCode, fromLocationSelect)
     if (success) {
       if (data.status) {
 
         if (data.finishProCode != proSelect) {
           SetBomSelect("")
           SetBomSelectName("")
           displayAlertMessage("danger", `Invalid BOM!`)
           return;
         }
 
         SetBomSelect(data.strBOMCode)
         SetBomSelectName(data.strBOMName)
 
         let { isSuccess, bomData } = await GetDetailAgainstBOM(type,data.strBOMCode, proSelect, fromLocationSelect)
 
         if (!isSuccess) {
           displayAlertMessage("danger", `Details are not available for this location !`)
           SetLoadingAlert(false)
           return
         }
 
         SetBaseProduct(bomData.strBase_Pro)
 
         // const basePro = bomData.bom_Details.find(x => x.strDET_PROCODE == bomData.strBase_Pro)
         // const filteredData = bomData.bom_Details.filter(x => x.strDET_PROCODE != bomData.strBase_Pro)
         // filteredData.unshift(basePro)
 
         const baseProIndex = bomData.bom_Details.findIndex(x => x.strDET_PROCODE === bomData.strBase_Pro)
 
         if (baseProIndex !== -1) {
           const filteredData = [...bomData.bom_Details.slice(0, baseProIndex), ...bomData.bom_Details.slice(baseProIndex + 1)]
           filteredData.splice(1, 0, bomData.bom_Details[baseProIndex])
 
           filteredData.map((item, index) => {
             // if (item.strDET_PROCODE == bomData.strBase_Pro) {
             //   item.dcDET_FCASEQTY = bomData.dcBom_Size
             // }
             item.dcDET_LINENO = index + 1
           })
           getGridTable(filteredData)
         } else {
           const filteredData = [...bomData.bom_Details]
 
           filteredData.map((item, index) => {
             item.dcDET_LINENO = index + 1
           })
           getGridTable(filteredData)
 
         }
         SetLoadingAlert(false)
       } else {
         displayAlertMessage("danger", `BOM not active !`)
         SetLoadingAlert(false)
       }
     } else {
       SetBomSelect("")
       SetBomSelectName("")
       displayAlertMessage("danger", `BOM not found !`)
       SetLoadingAlert(false)
     }
 
     SetLoadingAlert(false)
   }
 
 
 
   async function BomReCalculateFinishProAVGCost() {
 
     const finishProduct = DataRow.find((data) => data.strDET_PROCODE == proSelect);
     if (finishProduct) {
       finishProduct.dcDET_ACOST = parseFloat((parseFloat(Math.abs(bomFromValue)) / parseFloat(finishProduct.dcDET_FCASEQTY)) * parseFloat(finishProduct.dcDET_CS)).toFixed(txnDecimalAmt);
 
       const objectIndex = DataRow.findIndex(obj => obj.id === finishProduct.id);
       const newDataRow = [...DataRow];
       newDataRow[objectIndex] = finishProduct;
 
       SetDataRow(newDataRow);
       await TotalLineAmtCalcualtion(newDataRow);
     }
 
   }
 
 
   const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
 

   const consignmentOnClick = async () => {

    if(supplierSelect == ""){
      displayAlertMessage("danger", `Please Select Supplier !`)
      return
    }

    if(validFromDate == ""){
      displayAlertMessage("danger", `Please Select ${txn.strTX_VALIDFROMDATE_CAPTION == '' ? "Valid From *" : txn.strTX_VALIDFROMDATE_CAPTION}`)
      return
    }

    if(validToDate == ""){
      displayAlertMessage("danger", `Please Select ${txn.strTX_VALIDTODATE_CAPTION == '' ? "Valid To *" : txn.strTX_VALIDTODATE_CAPTION}`)
      return
    }


    try{
      SetLoadingAlert(true)
      SetLoadingAlerttitle("Loading consignment data...")
      const response = await getConsignmnetDatail(supplierSelect, validFromDate, validToDate, type, fromLocationSelect, toLocationSelect)

      if(response.isSuccess){
        getGridTable(response.data)
        SetRemarks1(response.reference)
        setGeneralFields(prev => ({
          ...prev,
          disableConsignment: true
        }))
      }else{
        displayAlertMessage("danger", `${response.message}`)
      }

    }catch(error){
      console.log(error)
    }finally{
      SetLoadingAlert(false)
    }


   }


  const exportDataToExcel = async () => {

    SetLoadingAlert(true);
    SetLoadingAlerttitle("Downloading file...");

    try{
      const response =  await exportTransactionDataToExcel(DataRow,supplierSelect,customerSelect,saleAssistantSelect,remarks1,remarks2,type)
      if(response){
        displayAlertMessage("success", "File downloaded successfully !")
      }else{
        displayAlertMessage("danger", "File download failed !")
      }
    }catch(error){
      console.log(error)
    }finally{
      SetLoadingAlert(false);
    }

  }


 async function saveIntialization(){
      setShow(false)
 
      //re-calculating the finish product average cost from using the total amount of the other line items except the finish product
      let valueDifference = 0
      if (txn.intTX_BOM == 1) {

        await BomReCalculateFinishProAVGCost()

        const { fromValue, toValue } = await calculateFromAndToValue(DataRow, proSelect, txn)

        valueDifference = parseFloat(Math.abs(fromValue)) - parseFloat(Math.abs(toValue))
      }

      //check current stock in hand and if the stock is not enough to save the transaction
      if ((txn.strTX_SOURCEINV == "-" && txn.intTX_CHKSIH == 1) || (txn.intTX_BOM == 1 && txn.intTX_CHKSIH == 1)) {


          setAlertDescription(txn.intTX_BOM == 1 && valueDifference > 0 ? `There is a ${parseFloat(valueDifference).toFixed(txnDecimalAmt)} difference between 'From value' and 'To value'. Do you want to do this value addition and continue saving ?` : "Do you wish to save ?")
          setAlertConfirmOption(1)
          setsweetAlertShow(true)

      } else {

        setAlertDescription(txn.intTX_BOM == 1 && valueDifference > 0 ? `There is a ${parseFloat(valueDifference).toFixed(txnDecimalAmt)} difference between 'From value' and 'To value'. Do you want to do this value addition and continue saving ?` : "Do you wish to save ?")
        setAlertConfirmOption(1)
        setsweetAlertShow(true)

      }
  }


  const validateGPVariation = async (username,password) => {
    
    try{

        setGeneralFields(prev => ({
          ...prev,
          gpVerifying: true
        }))

        const gpSpecialPermissonMenCode = MENUPERMISSION_GPVARIANCE

        let permissionList = await MenuUserpermission(username, password, gpSpecialPermissonMenCode)

        await delay(2000)

        if(permissionList.strMenuAccessRight){
          await saveIntialization()
        }else{
          displayAlertMessage("danger", "Entered user does not have permission!")
        }

    }catch(error){
        console.log(error)
        displayAlertMessage("danger", "Something went wrong while verifying user permission!")
    }finally{

        setGeneralFields(prev => ({
          ...prev,
          gpVerifying: false,
          gpPopupShow:false,
          gpVarianceList:[]
        }))

    }

  }




   return (
     <React.Fragment>
       <div className="page-content">
         <MetaTags>
           <title>{txn.strTX_DESC}</title>
         </MetaTags>
         <Container fluid={true}>
           <Breadcrumbs title={parentName} breadcrumbItem={txn.strTX_DESC} />
           <Row>
             <DPPrintOption
               confirm_both={printoptionShow}
               title={menuName}
               showCancel={true}
               cancelColor={"danger"}
               onConfirmpdf={() => {
                 handlePrint("PDF")
                 setprintoptionShow(false)
               }}
               onConfirmxcel={() => {
                 handlePrint("XCEL")
                 setprintoptionShow(false)
               }}
               onCancel={() => {
                 SetDocno("")
                 setprintoptionShow(false)
               }}
             />
             <DPLoadingAlert
               confirm_both={loadingAlert}
               title={loadingAlertTitle}
             />
             {/* processStat */}
             <Col lg={12}>
               <Card>
                 <CardBody>
                   <DPAlert
                     confirm_both={sweetAlertShow}
                     btnYes={btnYes}
                     title={txn.strTX_DESC}
                     description={AlertDescription}
                     showCancel={showCancel}
                     btnColor={"success"}
                     cancelColor={"danger"}
                     onConfirm={async () => {
                       setsweetAlertShow(false)
                       setshowCancel(true)
                       setBtnYes("Yes")
 
                       if (AlertConfirmOption == 1) {
 
                         setPermissionPassword("")
                         setReason("")
                         transactionProcess = 0
                         SetTxnProcess(0)
 
                         if (docNo.length == 0 && menuCreate == true && permissionReasonShow == false) {
                           if (txn.intTX_TEMPSAVE == 0) {
                             SaveTransaction()
                           } else {
 
 
                             setAlertDescription("Do you wish to process this document ?")
                             setAlertConfirmOption(5)
                             setsweetAlertShow(true)
                           }
                         } else if (docNo.length == 0 && menuCreate == true && permissionReasonShow == true) {
                           if (txn.intTX_TEMPSAVE == 1) {
                             setAlertDescription("Do you wish to process this document ?")
                             setAlertConfirmOption(5)
                             setsweetAlertShow(true)
                           } else {
                             setPermissionName(LogUserType)
                             setPermissionNameDisable(true)
                             setPermissionAlertShow(true)
                           }
 
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == false) {
                           if (txn.intTX_TEMPSAVE == 0) {
                             SaveTransaction()
                           } else {
                             setAlertDescription("Do you wish to process this document ?")
                             setAlertConfirmOption(5)
                             setsweetAlertShow(true)
                           }
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == true) {
                           if (txn.intTX_TEMPSAVE == 1) {
                             setAlertDescription("Do you wish to process this document ?")
                             setAlertConfirmOption(5)
                             setsweetAlertShow(true)
                           } else {
                             setPermissionName(LogUserType)
                             setPermissionNameDisable(true)
                             setPermissionAlertShow(true)
                           }
                           // setPermissionName(LogUserType)
                           // setPermissionNameDisable(true)
                           // setPermissionAlertShow(true)
                         } else {
                           if (txn.intTX_TEMPSAVE == 1) {
                             setAlertDescription("Do you wish to process this document ?")
                             setAlertConfirmOption(5)
                             setsweetAlertShow(true)
                           } else {
                             // setPermissionName(LogUserType)
                             setPermissionName("")
                             setPermissionNameDisable(false)
                             setPermissionNameDisable(true)
                             setPermissionAlertShow(true)
                           }
                           // setPermissionReasonShow(true)
                           // setPermissionAlertShow(true)
                         }
 
 
                       } else if (AlertConfirmOption == 2) {
                         handleEdit()
                       } else if (AlertConfirmOption == 3) {
                         history.push('/dashboard')
                       } else if (AlertConfirmOption == 4) {
                         setShow(false)
                         ClearItem()
                       } else if (AlertConfirmOption == 5) {
 
                         transactionProcess = 1
                         SetTxnProcess(1)
 
                         if (docNo.length == 0 && menuCreate == true && permissionReasonShow == false) {
                           SaveTransaction(1)
                         } else if (docNo.length == 0 && menuCreate == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == false) {
                           SaveTransaction(1)
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else {
                           setPermissionName("")
                           setPermissionNameDisable(false)
                           setRequiredReason(true)
                           setPermissionAlertShow(true)
                         }
 
                       } else if (AlertConfirmOption == 6) {
 
                         if (menuPrint == true && permissionReasonShow == false) {
                           setprintoptionShow(true)
                         } else if (menuPrint == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else {
                           setPermissionName("")
                           setPermissionNameDisable(false)
                           setRequiredReason(true)
                           setPermissionAlertShow(true)
                         }
 
                         // setprintoptionShow(true)
                       } else if (AlertConfirmOption == 7) {
                         if (menuDelete == true && permissionReasonShow == false) {
                           CancelCurrenctTransaction()
                         } else if (menuDelete == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else {
                           setPermissionName("")
                           setPermissionNameDisable(false)
                           setRequiredReason(true)
                           setPermissionAlertShow(true)
                         }
                       } else if (AlertConfirmOption == 8) {
                         getMobileData()
                       } else if (AlertConfirmOption == 10) {
                         GenerateItemUnitCountFromSubdoc()
                       } else if (AlertConfirmOption == 12) {
                         const shelData = await GetShelfManager(type, LogUserType, fromLocationSelect)
                         setShelfDataSet(shelData)
                         mobileManToggle()
                       } else if (AlertConfirmOption == 50) {
                         AutoOrder()
                       }
                     }}
                     onCancel={() => {
                       setsweetAlertShow(false)
                       setshowCancel(true)
                       setBtnYes("Yes")
                       setPermissionPassword("")
                       setReason("")
                       if (AlertConfirmOption == 5) {
                         SetTxnProcess(0)
                         if (docNo.length == 0 && menuCreate == true && permissionReasonShow == false) {
                           SaveTransaction(0)
                         } else if (docNo.length == 0 && menuCreate == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == false) {
                           SaveTransaction(0)
                         } else if (docNo.length > 0 && menuModify == true && permissionReasonShow == true) {
                           setPermissionName(LogUserType)
                           setPermissionNameDisable(true)
                           setPermissionAlertShow(true)
                         } else {
                           setPermissionName("")
                           setPermissionNameDisable(false)
                           setRequiredReason(true)
                           setPermissionAlertShow(true)
                         }
 
                       }
                     }}
                   />
                   <DPPermission
                     confirm_both={permissionAlertShow}
                     title={AlertConfirmOption == 100 ? "Under Cost" : menuName}
                     description={permissionAlertTitle}
                     showReason={permissionReasonShow == true && requiredReason == true ? true : permissionReasonShow == false && requiredReason == true ? true : permissionReasonShow == true && requiredReason == false ? true : false}
                     nameDisable={permissionNameDisable}
                     showCancel={true}
                     btnColor={"success"}
                     cancelColor={"danger"}
                     AlName={permissionName}
                     show={permissionGrantedAlertShow}
                     AlertColor={permissionGrantedAlertColor}
                     AlertMsg={permissionGrantedAlertMsg}
                     AlNameOnchange={e => {
                       let val2 = Text(e.target, 50, true, false, "any", false)
                       setPermissionName(val2)
                     }}
                     AlPassward={permissionPassword}
                     AlPasswardOnchange={e => {
                       let val2 = Text(e.target, 50, true, true, "any", false)
                       setPermissionPassword(val2)
                     }}
                     AlReason={Reason}
                     AlReasonOnchange={e => {
                       let val2 = Text(e.target, 50, true, false, "any", true)
                       setReason(val2)
                     }}
                     onConfirm={() => {
                       setPermissionAlertShow(false)
                       if (AlertConfirmOption == 1) {
                         UserPermission("Save")
                       } else if (AlertConfirmOption == 5) {
                         UserPermission("Save")
                       } else if (AlertConfirmOption == 7) {
                         UserPermission("Delete")
                       } else if (AlertConfirmOption == 6) {
                         UserPermission("Print")
                       }
                     }}
                     onCancel={() => {
                       setPermissionAlertShow(false)
                     }}
                   />
 
                   {/*special user permissions*/}
                   <DPPermission
                     confirm_both={specialPermissionAlertShow}
                     title={menuName}
                     description={specialPermissionAlertTitle}
                     showReason={false}
                     nameDisable={false}
                     showCancel={true}
                     btnColor={"success"}
                     cancelColor={"danger"}
                     show={permissionGrantedAlertShow}
                     AlertColor={permissionGrantedAlertColor}
                     AlertMsg={permissionGrantedAlertMsg}
 
                     AlName={specialPermissionName}
                     AlNameOnchange={e => {
                       let val2 = Text(e.target, 50, true, false, "any", false)
                       setSpecialPermissionName(val2)
                     }}
                     AlPassward={specialPermissionPassword}
                     AlPasswardOnchange={e => {
                       let val2 = Text(e.target, 50, true, true, "any", false)
                       setSpecialPermissionPassword(val2)
                     }}
 
                     onConfirm={async () => {
 
                       //CHECK SPECIAL PERMISSIONS FOR SPECIAL FUNCTIONS
                       let permissionList = await MenuUserpermission(specialPermissionName, specialPermissionPassword, specialPermissonMenCode, specialPermissionCode)
 
 
                       //97 - allow to enter unit more than stock in hand 
 
                       if (specialPermissionCode == 97 && permissionList.strMenuAccessRight) {
 
                         setPermissionGrantedAlertShow(true)
                         setPermissionGrantedAlertColor("success")
                         setPermissionGrantedAlertMsg("Permission Granted Successfully !")
                         setTimeout(async () => {
                           setPermissionGrantedAlertShow(false)
                           setSpecialPermissionAlertShow(false)
 
                           let valueDifference = 0;
                           if (txn.intTX_BOM == 1) {
 
                             await BomReCalculateFinishProAVGCost()
                             const { fromValue, toValue } = await calculateFromAndToValue(DataRow, proSelect, txn)
 
                             valueDifference = parseFloat(Math.abs(fromValue)) - parseFloat(Math.abs(toValue))
                           }
 
                           setAlertDescription(txn.intTX_BOM == 1 && valueDifference > 0 ? `There is a ${parseFloat(valueDifference).toFixed(txnDecimalAmt)} difference between 'From value' and 'To value'. Do you want to do this value addition and continue saving ?` : "Do you wish to save ?")
                           setAlertConfirmOption(1)
                           setsweetAlertShow(true)
                         }, 2000);
                       } else {
                         setPermissionGrantedAlertShow(true)
                         setPermissionGrantedAlertColor("danger")
                         setPermissionGrantedAlertMsg("This user don't have permission !")
                         setTimeout(() => {
                           setPermissionGrantedAlertShow(false)
                           setSpecialPermissionAlertShow(false)
                         }, 3000);
                       }
 
                     }}
                     onCancel={() => {
                       setSpecialPermissionAlertShow(false)
                     }}
                   />
 
                   <Row>
                     <Col lg={10} md={12} sm={12}>
                       <DPTopToolBar
                         //Help Button
                         helpEnable={helpUrl != "" ? true : false}
                         helpClick={() => {
                           window.open(helpUrl)
                         }}
                         //Favorite Button
                         favoriteEnable={true}
                         favoriteClick={handleFavourite}
                         //New Button
                         newEnable={true}
                         newClick={() => {
                           setAlertDescription("Do you wish to refresh the screen ?")
                           setAlertConfirmOption(4)
                           setsweetAlertShow(true)
                         }}
                         //Save Button
                         saveEnable={
                           txn.intTX_NOTCREATABLE == 1 ? false : isSaving? false : saveBtnEnable
                         }
                         saveClick={async () => {
              

                          if(txn.intTX_VALIDATE_GP_VARIANCE == 1){
                            
                            const itemList = DataRow.filter(item => item.strDET_PROCODE != "" && item.strDET_PROCODE != null && item.strDET_PROCODE != undefined)

                            const gpVarianceItems = itemList
                                              .map(item => {
                                                const cost = parseFloat(item.dcDET_CPRICE) / parseFloat(item.dcDET_CS);
                                                const sp = parseFloat(item.dcDET_SPRICE);
                                                const currentGP = ((sp - cost) / sp) * 100;
                                                return {
                                                  lineNo: item.id,
                                                  proCode: item.strDET_PROCODE,
                                                  proName: item.strDET_PRODESC,
                                                  stockCode: item.strDET_STOCKCODE,
                                                  cost: item.dcDET_CPRICE,
                                                  selling: item.dcDET_SPRICE,
                                                  currentGP: currentGP.toFixed(2),
                                                  fixGP: parseFloat(item.fixGP).toFixed(2),
                                                  isMismatch: parseFloat(item.fixGP).toFixed(2) !== currentGP.toFixed(2)
                                                };
                                              })
                                              .filter(item => item.isMismatch);

                            if (gpVarianceItems.length > 0) {

                              setGeneralFields(prev => ({
                                          ...prev,
                                          gpPopupShow: true,
                                          gpVarianceList: gpVarianceItems
                                        }))

                            } else {

                              await saveIntialization()

                            }                 
                            
                          } else {

                              await saveIntialization()

                          }

                         }}

                         //ProcessButton
                         processEnable={
                           txn.intTX_NOTCREATABLE == 1 ? false : false
                         }
                         processClick={() => {
                           alert()
                         }}
 
                         //Edit Button
                         editEnable={
                           txn.intTX_NOTCREATABLE == 1
                             ? false
                             : txn.intTX_STOCKFREEZE == 1 ? false : processStat == "Processed" || cancelDoc != ""
                               ? false
                               : !saveBtnEnable
                         }
                         editClick={() => {
                           setAlertDescription("Do you wish to edit ?")
                           setAlertConfirmOption(2)
                           setsweetAlertShow(true)
                         }}
                         //Print Button
                         printEnable={!saveBtnEnable}
                         printClick={() => {
                           //txnNo = docNo
                           setAlertDescription(
                             "Do you wish to print this document ?"
                           )
                           setAlertConfirmOption(6)
                           setsweetAlertShow(true)
                         }}
                         //Delete Button
                         deleteEnable={
                           txn.intTX_NOCANCELLATION == 1
                             ? false
                             : processStat != "" || cancelDoc != ""
                               ? true
                               : !saveBtnEnable
                         }
                         deleteClick={() => {
                           setAlertDescription("Do you wish to cancel this document ?")
                           setAlertConfirmOption(7)
                           setsweetAlertShow(true)
                         }}
                         deleteTitle={"Cancel"}
                         //Exit Button
                         exitEnable={true}
                         exitClick={() => {
                           setAlertDescription("Do you wish to exit ?")
                           setAlertConfirmOption(3)
                           setsweetAlertShow(true)
                         }}
                       />
                     </Col>
                     <Col lg={2} md={6} sm={6} style={{ marginLeft: "-20px" }}>
                       <div className="d-flex justify-content-end">
                         <div className="d-flex justify-content-between">
                           <img
                             src={mobileman}
                             onClick={() => {
                               if (RefCode == "") {
 
                                 if (fromLocationSelect == "") {
                                   setAlertDescription("Please select from location")
                                   setAlertConfirmOption(100)
                                   setsweetAlertShow(true)
                                   return
                                 }
                                 setAlertDescription("Do you want to download details from Mobileman?")
                                 setAlertConfirmOption(12)
                                 setsweetAlertShow(true)
                               } else {
                                 setAlertDescription("Do you want to get quantiity from Mobileman?")
                                 setAlertConfirmOption(8)
                                 setsweetAlertShow(true)
                               }
 
                             }}
                             alt="logo"
                             title="Import from Mobile Man !"
                             style={{
                               width: "40px",
                               backgroundColor: "white",
                               cursor: "pointer",
                               opacity: disabled == true ? "0.5" : "1",
                             }}
                           />
                           <li
                             className="import-export-button"
                             style={{ display: "block" }}
                           >
                             <input
                               id="file"
                               type="file"
                               accept=".xlsx, .xls"
                               onChange={handleFileChange}
                               fileInputRef={fileInputRef}
                               disabled={disabled}
                               style={{ display: "none" }}
                             />
                             <label
                               htmlFor="file"
                               title="Import from Excel !"
                               style={{
                                 cursor: "pointer",
                                 opacity: disabled == true ? "0.5" : "1",
                               }}
                             >
                               <span>
                                 <img
                                   htmlFor="file"
                                   src={excelicon}
                                   alt="logo"
                                   title="Import from Excel !"
                                   style={{
                                     width: "40px",
                                     height: "100%",
                                     backgroundColor: "white",
                                     cursor: "pointer",
                                   }}
                                 />
                               </span>
                             </label>
                           </li>
                         </div>
                       </div>
 
                     </Col>
                     {/* <Col lg={1} md={6} sm={6} style={{ marginLeft: "-20px" }}>
 
                     </Col> */}
                   </Row>
 
                   {processStat != "" && cancelDoc == "" ? (
                     <Alert
                       color={processStat == "Processed" ? "dark" : processStat == "Unprocessed" ? "dark" : "light"}
                       role="alert"
                     >
                       {processStat + fullyUsd + " Document !"}
                     </Alert>
                   ) : null}
                   {cancelDoc != "" ? (
                     <Alert color={"danger"} role="alert">
                       {cancelDoc}
                     </Alert>
                   ) : null}
                   {show ? (
                     <Alert color={AlertColor} role="alert">
                       {AlertMsg}
                       <br />
                       {/*<small>{ErrorMsg}</small>*/}
                     </Alert>
                   ) : null}
                   <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                   <DPTxnProduct
                     isOpen={productErrorToggle}
                     toggle={ProductErrorModleToggle}
                     SubTitle={"Validation Failed due to following reason(s)"}
                     Data={ProductErrorData}
                   />
                   <DPTxnProductSIH
                     isOpen={productSIHChangesToggle}
                     toggle={ProductSIHChangesToggleFunc}
                     SubTitle={"Stock in Hand has been changed for following item(s)"}
                     Data={productSIHChangesData}
                     continueOnClick={() => {
                       ProductSIHChangesToggleFunc()
                       setSpecialPermissionCode(97)
                       setSpecialPermissionAlertShow(true)
                       setSpecialPermissionAlertTitle("Allowing Stock In Hand Changes !")
                       setSpecialPermissonMenCode("P00126")
                     }}
                   />
                   <TabContent activeTab={customActiveTab} className="p-3 text">
                     <TabPane tabId="1">
                       <TransactionHED
                         modelTrigger={tog_xlarge}
                         SupmodelTrigger={SupplierSearch_Tog}
                         CusmodelTrigger={CustomerSearch_Tog}
                         BommodelTrigger={BomSearch_Tog}
                         PromodelTrigger={ProSearch_Tog}
                         SAmodelTrigger={SASearch_Tog}
                         RefmodelTrigger={Reftog_xlarge}
                         SupmodelOpen={Suppmodal_xlarge}
                         CusmodelOpen={Cusmodal_xlarge}
                         BommodelOpen={Bommodal_xlarge}
                         PromodelOpen={Promodal_xlarge}
                         SAmodelOpen={SAmodal_xlarge}
                         modelOpen={modal_xlarge}
                         RefmodelOpen={Refmodal_xlarge}
                         GetSupSelectRow={GetSupSelectRow}
                         GetCusSelectRow={GetCusSelectRow}
                         GetProSelectRow={GetProSelectRow}
                         GetBomSelectRow={GetBomSelectRow}
                         GetSASelectRow={GetSASelectRow}
                         GetSelectRow={GetSelectRow}
                         GetRefSelectRow={GetRefSelectRow}
                         DataRow={DataRow}
                         AddRow={AddRow}
                         RemoveRow={RemoveRow}
                         customerSelect={customerSelect}
                         customerTypeOnchange={e => {
                           let codeRaw = Text(e.target, 30, true, false, 'any', false)
                           SetCustomerSelect(codeRaw)
                         }}
                         customerOnBlur={async (e) => {
                           if (e.target.value != "") {
                             getCustomer(e.target.value)
                           } else {
                             SetCustomerSelect("")
                             SetCustomerSelectName("")
 
                           }
                         }}
                         salesAssistOnchange={e => {
                           let codeRaw = Text(e.target, 30, true, false, 'any', false)
                           SetSalesAssistantSelect(codeRaw)
                         }}
                         salesAssistOnBlur={async (e) => {
                           if (e.target.value != "") {
                             getSalesAssist(e.target.value)
                           } else {
                             SetSalesAssistantSelect("")
                             SetSalesAssistantSelectName("")
                           }
                         }}
 
                         bomSelect={bomSelect}
                         bomSelectName={bomSelectName}
                         bomOnChange={e => {
                           let codeRaw = Text(e.target, 30, true, false, 'any', false)
                           SetBomSelect(codeRaw)
                         }}
                         bomOnBlur={async (e) => {
 
                           if (proSelect == "") {
                             setAlertDescription("Please Select Finish Product First")
                             setAlertConfirmOption(100)
                             setshowCancel(false)
                             setsweetAlertShow(true)
                             setBtnYes("Ok")
                             SetBomSelect("")
                             SetBomSelectName("")
                             return
                           }
 
                           if (fromLocationSelect == "") {
                             setAlertDescription("Please Select Location !")
                             setAlertConfirmOption(100)
                             setshowCancel(false)
                             setsweetAlertShow(true)
                             setBtnYes("Ok")
                             SetBomSelect("")
                             SetBomSelectName("")
                             return
                           }
 
                           if (e.target.value != "") {
                             getSelectedBOM(e.target.value)
                           } else {
                             SetBomSelect("")
                             SetBomSelectName("")
                           }
                         }}
                         proSelect={proSelect}
                         proSelectName={proSelectName}
                         salesAssistantSelect={saleAssistantSelect}
                         saleAssistantSelectName={saleAssistantSelectName}
                         supplierSelect={supplierSelect}
                         supplierSelectName={supplierSelectName}
                         customerSelectName={customerSelectName}
                         toLocationSelect={toLocationSelect}
                         fromLocationSelect={fromLocationSelect}
                         deliLocationSelect={deliLocationSelect}
                         customerOnChange={e => {
                           SetCustomerSelect(e["value"])
                           FocusOnEvent("txtCustomer", txn)
                         }}
                         salesAssistantOnChange={e => {
                           SetSalesAssistantSelect(e["value"])
                           FocusOnEvent("txtSA", txn)
                         }}
                         priceModeSelect={priceModeSelect}
                         priceModeOnChange={e => {
                           SetPriceModeSelect(e["value"])
                           FocusOnEvent("txtPriceMode", txn)
                         }}
                         supplierOnChange={e => {
                           let codeRaw = Text(
                             e.target,
                             13,
                             true,
                             false,
                             "upper",
                             false
                           )
                           SetSupplierSelect(codeRaw)
                         }}
                         supplierOnBlur={async (e) => {
                           if (e.target.value != "") {
                             getSupplier(e.target.value)
                           } else {
                             SetSupplierSelect("")
                             SetSupplierSelectName("")
                             SetSupplierContribution(0)
                             SetSkipSupplierApproval(false)
                           }
                         }}
                         toLocationOnChange={async (e) => {
                           SetToLocationSelect(e["value"])
                           FocusOnEvent("txtToLoc", txn)
 
                           if (txn.intTX_ORDER_TRANSACTION == 1 && txn.intTX_LOCATION_RELATED_SUPPLIER == 1) {
                             const response = await getLocationSupplier(e["value"])
                             if (response.isSuccess) {
                               SetSupplierSelect(response.data.code)
                               SetSupplierSelectName(response.data.name)
                               const response = await getTransactionTax(txn.intTX_TAXH_CODE, data.code, type)
                               setTxnTaxTypes(response.data)
                             } else {
                               SetSupplierSelect("")
                               SetSupplierSelectName("")
                               setTxnTaxTypes([])
                             }
                           }
 
                         }}
 
                         fromLocationOnChange={e => {
 
                           SetFromLocationSelect(e["value"])
                           FocusOnEvent("txtFromLoc", txn)
                           if (txn.intTX_SHOWVAR == 1) {
                             // RefCodeOnBlur(RefCode, e["value"], true)
                           }
                         }}
                         SetFromLocationSelect={SetFromLocationSelect}
                         deliLocationOnChange={e => {
                           SetDeliLocationSelect(e["value"])
                           FocusOnEvent("txtDeliLoc", txn)
                         }}
                         CodeValue={docNo}
                         CodeonChange={e => {
                           let codeRaw = Text(
                             e.target,
                             13,
                             true,
                             false,
                             "upper",
                             false
                           )
                           SetDocno(codeRaw)
                         }}
                         CodeOnBlur={code => {
                           CodeOnBlur(code)
                         }}
                         disabledCode={docNoDisable}
                         disabledRemarks={disabledRemarks}
                         disabledPriceMode={disabledPriceMode}
                         disabledCustomer={disabledCustomer}
                         disabledDate={dateDisableFields}
                         disabledSupplier={disabledSupplier}
                         disabledRefType={disabledRefType}
                         disabledSA={disabledSA}
                         disabledFL={disabledFL}
                         disabledTL={disabledTL}
                         disabledDL={disabledDL}
                         disabled={disabled}
                         Remarks1Value={remarks1}
                         Remarks1OnChange={e => {
                           let rem1 = Text(e.target, 50, true, true, "any", true)
                           SetRemarks1(rem1)
                         }}
                         Remarks2Value={remarks2}
                         summaryRemarksList={summaryRemarksList}
                         Remarks2OnChange={e => {
                           SetRemarks2(e["value"])
                         }}
                         txnDate={txndate}
                         txnDateOnChange={e => {
 
                           //check if selected date is less than current date
                           // if (new Date(e.target.value) < new Date()) {
                           //   displayAlertMessage("danger", "Selected date cannot be less than current date")
                           //   var today = new Date()
                           //   SetTxnDate(today.toISOString().slice(0, 10))
                           //   setValidDay(today.toISOString().slice(0, 10))
                           //   return
                           // }
 
                           SetTxnDate(e.target.value)
                           if (txn.intTX_VALIDDAYS > 0) {
                             if (e.target.value) {
                               var txnDat = new Date(e.target.value)
                               var tomorrow = new Date(e.target.value)
                               tomorrow.setDate(txnDat.getDate() + parseInt(txn.intTX_VALIDDAYS))
                               setValidDay(tomorrow.toISOString().slice(0, 10))
                             }
                           } else {
                             setValidDay(e.target.value)
                           }
 
                         }}
                         validDay={validDay}
                         SetValidDay={e => {
 
                           //if selected date is less than txndate 
                           if (new Date(e.target.value) < new Date(txndate)) {
                             displayAlertMessage("danger", "Selected date cannot be less than transaction date")
                             var today = new Date()
                             setValidDay(today.toISOString().slice(0, 10))
                             return
                           }
 
                           setValidDay(e.target.value)
                         }}
                         txn={txn}
                         type={type}
                         RefCode={RefCode}
                         txRefAmount={txRefAmount}
                         SetRefAmount={e => {
                           let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                           SetRefAmount(
                             txt.toLocaleString(undefined, {
                               maximumFractionDigits: txnDecimalAmt,
                               minimumFractionDigits: 2,
                             })
                           )
                         }}
                         RefAmountOnBlur={e => {
 
                           const enteredValue = String(e.target.value).replace(/,/g, '')
 
                           let formatedVal = DecimalValidation(enteredValue, 0, true, txnDecimalAmt)
 
                           if (e.target.value != "") {
                             SetRefAmount(formatedVal)
                           } else {
                             SetRefAmount(formatedVal)
                           }
 
                         }}
                         RefCodeOnChange={e => {
                           let refcodeRaw = Text(e.target, 13, true, false, "upper", false)
                           SetRefCode(refcodeRaw)
                         }}
                         RefCodeOnBlur={e => {
                           RefCodeOnBlur(e.target.value)
                         }}
                         //refTypeOption={}
                         refTypeSelected={refTypeSelected}
                         refTypeOnchange={e => {
                           SetRefTypeSelected(e["value"])
                         }}
                         SetRefTypeSelected={SetRefTypeSelected}
                         menuCode={menuCode}
                         fromLocations={fromLocations}
                         toLocations={toLocations}
                         SetFromLocation={SetFromLocation}
                         validToDate={validToDate}
                         validFromDate={validFromDate}
                         SetValidFromDate={e => {
                           SetValidFromDate(e.target.value)
                         }}
                         SetValidToDate={e => {
                           SetValidToDate(e.target.value)
                         }}
                         RefDataRow={RefDataRow}
                         handleClearStatus={handleClearStatus}
                         finishProOnchange={e => {
                           let codeRaw = Text(e.target, 30, true, false, "any", false)
                           SetProSelect(codeRaw)
                         }}
                         finishProOnBlur={async (e) => {
                           if (e.target.value != "") {
                             getFinishPro(e.target.value)
                           } else {
                             SetProSelect("")
                             SetProSelectName("")
                           }
                         }}
                         LocationCode={LocationCode}
                         glBatchNo={glBatchNo}

                       />
                     </TabPane>
                     <TabPane tabId="2">
                       <TransactionDET
                         processStat={processStat}
                         toLocationSelect={toLocationSelect}
                         setPermissionAlertShow={setPermissionAlertShow}
                         setAlertConfirmOption={setAlertConfirmOption}
                         setsweetAlertShow={setsweetAlertShow}
                         setAlertDescription={setAlertDescription}
                         AlertConfirmOption={AlertConfirmOption}
                         Reason={Reason}
                         setReason={setReason}
                         menuName={menuName}
                         menuCode={menuCode}
                         PayDataRow={PayDataRow}
                         AddPayRow={AddPayRow}
                         loccode={fromLocationSelect}
                         TxnTotalCal={TxnTotalCal}
                         DataRow={DataRow}
                         SetDataRow={SetDataRow}
                         RefDataRow={RefDataRow}
                         AddRow={AddRow}
                         RemoveRow={RemoveRow}
                         type={type}
                         txn={txn}
                         lineDisc={lineDisc}
                         GrossTotal={GrossTotal}
                         txDiscount={txDiscount}
                         txDiscountAmt={txDiscountAmt}
                         txAddition={txAddition}
                         txDeduction={txDeduction}
                         txTaxInc={txTaxInc}
                         txTaxExc={txTaxExc}
                         txNetAmount={txNetAmount}
                         supplierSelect={supplierSelect}
                         validToDate={validToDate}
                         validFromDate={validFromDate}
                         SetGrossTotaltx={SetGrossTotal}
                         SetTxDiscount={e => {
                           let txt = Numeric(e.target, 8, txnDecimalAmt, false)
 
                           // let txt = DecimalValidation(e.target.value, 0, true, 2)
                           if (parseFloat(txt) <= 100) {
                             SetTxDiscount(txt)
                           } else if (e.target.value == "") {
                             SetTxDiscount(0)
                           }
                         }}
                         SetTxAddition={e => {
                           let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                           if (txt == "") {
                             txt = 0
                           }
                           SetTxAddition(txt)
                         }}
                         SetTxTaxInc={SetTxTaxInc}
                         SetTxTaxExc={SetTxTaxExc}
                         SetLineDisc={SetLineDisc}
                         SetTxDeduction={e => {
                           let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                           if (txt == "") {
                             txt = 0
                           }
                           SetTxDeduction(txt)
                         }}
                         SetTxNetAmount={SetTxNetAmount}
                         TaxDetails={TaxDetails}
                         taxTable={taxTable}
                         SetTaxtTable={SetTaxtTable}
                         newTaxTable={newTaxTable}
                         setNewTaxTable={setNewTaxTable}
                         DisableDet={DisableDet}
                         PaidAmt={totalPayValue}
                         DueAmt={parseFloat(txNetAmount) - parseFloat(totalPayValue)}
                         TotalPayCalculation={TotalPayCalculation}
                         clearStatus={handleClearStatus}
                         setTaxProductCodes={setTaxProductCodes}
                         taxProductCodes={taxProductCodes}
                         SetTaxLineRemarks={SetTaxLineRemarks}
                         TaxLineRemarks={TaxLineRemarks}
                         setAlertColor={setAlertColor}
                         setAlertMsg={setAlertMsg}
                         setShow={setShow}
                         priceModeSelect={priceModeSelect}
                         SetPayDataRow={SetPayDataRow}
                         baseProduct={baseProduct}
                         proSelect={proSelect}
                         TotalLineAmtCalcualtion={TotalLineAmtCalcualtion}
                         setReasonForDetails={setReasonForDetails}
                         reasonForDetails={reasonForDetails}
                         AutoOrder={AutoOrder}
                         RefStockFreeze={refStockFreeze}
                         bomToValue={bomToValue}
                         bomFromValue={bomFromValue}
                         RefCode={RefCode}
                         BomReCalculateFinishProAVGCost={BomReCalculateFinishProAVGCost}
                         supplierContribution={supplierContribution}
                         txnTaxTypes={txnTaxTypes}
                         customerSelect={customerSelect}
                         txRefAmount={txRefAmount}
                         detailReasonTypes={detailReasonTypeList}
                         consignmentOnClick={consignmentOnClick}
                         generalFields={generalFields}
                         exportDataToExcel={exportDataToExcel}
                       />
                     </TabPane>
                     <TabPane tabId="3">
                       <TransactionRemHED
                         DataRow={RemHedDataRow}
                         menuCode={menuCode}
                         DisableDet={DisableDet}
                         SetRemHedDataRow={SetRemHedDataRow}
                       />
                     </TabPane>
                     <TabPane tabId="4">
                       <TransactionAttach
                         selectedAttachFiles={selectedAttachFiles}
                         setAttachFileNames={setAttachFileNames}
                         attachFileNames={attachFileNames}
                         setSelectedAttachFiles={setSelectedAttachFiles}
                         clearStatus={handleClearStatus}
                         disable={DisableDet}
                         clearAttachmentEdit={clearAttachmentEdit}
                       />
                     </TabPane>
                     <TabPane tabId="5">
                       <TransactionSubDocs
                         subDocs={subDocs}
                         setSubDocs={setSubDocs}
                         setSubDocApprove={setSubDocApprove}
                         Disable={DisableDet}
                         txn={txn}
                         Location={fromLocationSelect}
                         Transaction={type}
                         getGridTable={getGridTable}
                         setAlertColor={setAlertColor}
                         setAlertMsg={setAlertMsg}
                         setShow={setShow}
                         TotalLineAmtCalcualtion={TotalLineAmtCalcualtion}
                         SetTaxtTable={SetTaxtTable}
                         supplierSelect={supplierSelect}
                         setProductErrorData={setProductErrorData}
                         setProductErrorToggle={setProductErrorToggle}
                       />
                     </TabPane>
                     <TabPane tabId="6">
                       <Approvel
                         txn={txn}
                         DocNo={docNo}
                         DocDate={txndate}
                         LocCode={LocationCode}
                         User={crBy}
                         NetValue={txNetAmount}
                         ApprovelDetails={remoteData}
                         getData={getData}
                         Transaction={type}
                         SetLoadingAlert={SetLoadingAlert}
                         SetLoadingAlerttitle={SetLoadingAlerttitle}
                        />
                     </TabPane>
                   </TabContent>
                   <DPSearchBoxDynamic
                     searchData={[]}
                     columns={[]}
                     defaultSorted={defaultSorted}
                     mainTitle={"Mobile Man Search"}
                     SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                     isOpen={modal_xlargeM}
                     toggle={tog_xlargeM}
                     getSelect={getMobileData}
                     APIURL={ApiURL}
                     URLPath={"MOBILEMAN"}
                     MenuCode={menuCode}
                     KeyVal={"TXN"}
                     searchBy={"SC_SHELFID"}
                     FilterStr={"a"}
                   />
                   <PendingApprovels
                     isOpen={AppWindowShow}
                     toggle={toggleApp}
                     SubTitle={"This document not processed !"}
                     Details={"These approvals must be obtained to proceed with this document."}
                     txn={txn}
                     DocNo={docNo}
                     DocDate={txndate}
                     LocCode={fromLocationSelect}
                     User={userName}
                     NetValue={txNetAmount}
                     ApprovelDetails={remoteRequest}
                     getData={getData}
                   />
                   <DPMobilePopUp
                     isOpen={mobileToggle}
                     toggle={mobileManToggle}
                     handleMobileManRowClick={handleMobileManRowClick}
                     data={shelfDataSet}
                   />
                   <MobileManUserModel
                     isOpen={mobileManDetailPopup.isOpen}
                     itemList={mobileManDetailPopup.items}
                     onRowSelected={mobileManDetailPopup.onRowSelected}
                     toggle={mobileManDetailPopup.toggle}
                     refTypeSelected={refTypeSelected}
                     fromLocationSelect={fromLocationSelect}
                     gridData={DataRow}
                   />

                  <DateRangeModal
                    isOpen={generalFields.autoOrderShow}
                    toggle={()=>{
                      setGeneralFields(prev => ({
                        ...prev,
                        autoOrderShow: !prev.autoOrderShow
                      }))
                    }}
                    onApply={getAutoOrderData}
                    supplier={supplierSelect}
                    validFromDate={validFromDate}
                    validToDate={validToDate}
                    generalFields={generalFields}
                    setGeneralFields={setGeneralFields}
                  />

                    <ModelUserPermission
                      isOpen={generalFields.gpPopupShow}
                      toggle={() => {
                        setGeneralFields(prev => ({
                          ...prev,
                          gpPopupShow: !prev.gpPopupShow
                        }))
                      }}
                      data={generalFields.gpVarianceList}
                      onConfirm={validateGPVariation}
                      loading={generalFields.gpVerifying}
                    />
                   <Row>
                     {crEnable ? (
                       <DPInfoBox
                         createdBy={crBy}
                         createdOn={
                           crDate != "1900-01-01T00:00:00" ? crDate : ""
                         }
                         modifiedBy={mdBy}
                         modifiedOn={
                           mdDate != "1900-01-01T00:00:00" ? mdDate : ""
                         }
                       />
                     ) : null}
                   </Row>
                 </CardBody>
 
               </Card>
             </Col>
           </Row>
         </Container>
       </div>
     </React.Fragment>
   )
 }
 
 
 export default Transaction
 
 
 
 //pending developments
 
 //auto order tax calculation
 